import { Storage } from '../lib/storage';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Navigation, Share2, Users, Lock, Calendar, Edit3, Gift, Copy, CheckCircle, MessageCircle, AlertTriangle, Clock, X, Trash2, Search, Crown, Maximize2, Map, Shield, Trophy, Zap, Flag, ChevronRight, Activity, LogOut, AlertOctagon, RefreshCw } from 'lucide-react';
import { supabase } from '../lib/supabase';

// Datos Mockeados para demostrar la Mesa Redonda
const MOCK_LEADERBOARD = [
  { id: '1', alias: 'Jorge (TÚ)', moto: 'Dominar 400', kms: 450, esOro: true, isMe: true, celular: '' },
  { id: '2', alias: 'María', moto: 'MT-09', kms: 380, esOro: true, isMe: false, celular: '' },
  { id: '3', alias: 'Carlos', moto: 'NK 250', kms: 210, esOro: false, isMe: false, celular: '' },
  { id: '4', alias: 'Sebas', moto: 'Gixxer 250', kms: 150, esOro: false, isMe: false, celular: '' }
];

export default function ParcheScreen({ onOpenMembresia, modoEspejo = 'social' }: { onOpenMembresia?: () => void; modoEspejo?: 'social' | 'vip' }) {
  const [codigoCopiado, setCodigoCopiado] = useState(false);
  const [mostrarParche, setMostrarParche] = useState(false);
  const [mostrarChat, setMostrarChat] = useState(false);
  const [actualizando, setActualizando] = useState(false);
  const [busquedaParche, setBusquedaParche] = useState('');
  const [filtroOro, setFiltroOro] = useState(false);
  const [dialogoConfirmacion, setDialogoConfirmacion] = useState<{titulo?: string, mensaje: string, accion: () => void, soloAceptar?: boolean, color?: 'red' | 'emerald' | 'amber', cerrable?: boolean} | null>(null);
  const [dialogoInputNombre, setDialogoInputNombre] = useState<string | null>(null);
  const [mostrarFormSimit, setMostrarFormSimit] = useState(false);
  const [formSimit, setFormSimit] = useState({ nombre: '', cedula: '', placa: '' });
  const [mostrarCanje, setMostrarCanje] = useState(false);
  
  const [mostrarBroadcast, setMostrarBroadcast] = useState(false);
  const [mensajeBroadcast, setMensajeBroadcast] = useState('');
  const [enviandoBroadcast, setEnviandoBroadcast] = useState(false);

  // ESTADOS MESA REDONDA
  const [mostrarMesaRedonda, setMostrarMesaRedonda] = useState(false);
  const [escuadronActivo, setEscuadronActivo] = useState<{id: string, nombre: string, codigo: string, adminId: string, isPremium?: boolean, isSaturated?: boolean} | null>(null);
  const [modoEscuadron, setModoEscuadron] = useState<'decision' | 'fundar' | 'unirse'>('decision');
  const [nuevoNombreEscuadron, setNuevoNombreEscuadron] = useState('');
  const [creandoEscuadron, setCreandoEscuadron] = useState(false);
  const [codigoUnirse, setCodigoUnirse] = useState('');
  const [rutasClubArray, setRutasClubArray] = useState<any[]>([]);
  const [mostrarModalRutasClub, setMostrarModalRutasClub] = useState(false);
  const [asistenciasBoveda, setAsistenciasBoveda] = useState<Record<string, number>>({});
  const [asistentesBovedaDetalle, setAsistentesBovedaDetalle] = useState<Record<string, any[]>>({});
  const [rutaExpandida, setRutaExpandida] = useState<string | null>(null);

  const [miembrosEscuadron, setMiembrosEscuadron] = useState(MOCK_LEADERBOARD);

  const [invitadosParche, setInvitadosParche] = useState<{id:string, nombre:string, celular:string, esOro:boolean}[]>([]);
  const [puntosPorAuditoria, setPuntosPorAuditoria] = useState(0);
  
  // -- WALKIE TALKIE CHAT --
  const [mensajesChat, setMensajesChat] = useState<any[]>([]);
  const [nuevoMensaje, setNuevoMensaje] = useState("");
  const chatScrollRef = React.useRef<HTMLDivElement>(null);

  const [soyOroPuntos, setSoyOroPuntos] = useState(false);
  const [puntosGastados, setPuntosGastados] = useState(0);
  const [procesandoCanje, setProcesandoCanje] = useState(false);

  React.useEffect(() => {
    const fetchRecompensasYParche = async () => {
      const localId = Storage.get('gravity_user_id');
      if (!localId) return;
      
      // Intento de carga desde caché (Sombra de Datos)
      const cachedParche = Storage.get('gravity_cache_parche');
      if (cachedParche) {
         try { setInvitadosParche(JSON.parse(cachedParche)); } catch(e){}
      }

      const { data: ud } = await supabase.from('usuarios').select('es_oro, puntos_gastados').eq('id', localId).single();
      if (ud) {
         setSoyOroPuntos(!!ud.es_oro);
         setPuntosGastados(ud.puntos_gastados || 0);
      }

      const { data: dataParche } = await supabase.from('amigos_parche').select('*').eq('anfitrion_id', localId);
      if (dataParche) {
        // Traer avatars para los referidos (si están registrados)
        const celulares = dataParche.map(d => d.amigo_celular).filter(c => !!c);
        const { data: avatarsRef } = await supabase.from('usuarios').select('celular, avatar_url').in('celular', celulares);
        
        const finalParcheData = dataParche.map(d => {
           const uAvatar = avatarsRef?.find(av => av.celular === d.amigo_celular);
           return {
             id: d.id, 
             nombre: d.amigo_nombre, 
             celular: d.amigo_celular, 
             esOro: d.es_oro,
             avatar_url: uAvatar?.avatar_url
           };
        });

        setInvitadosParche(finalParcheData);
        Storage.set('gravity_cache_parche', JSON.stringify(finalParcheData));
      }

      const { data: dataAuditorias } = await supabase.from('cotizaciones').select('id, valor_motero, valor_final').eq('motero_id', localId).eq('auditor_motero', true);
      if (dataAuditorias) {
        const puntosMil = dataAuditorias.reduce((acc: number, item: any) => {
           const val = Number(item.valor_motero || item.valor_final || 0);
           return acc + Math.floor(val / 1000);
        }, 0);
        setPuntosPorAuditoria(puntosMil);
      }
    };
    fetchRecompensasYParche();
  }, [escuadronActivo?.id, modoEscuadron]);

  // -- Radar de Pilotos Confirmados (Bóveda) --
  React.useEffect(() => {
    if (mostrarModalRutasClub && rutasClubArray.length > 0) {
       // Cargar desde caché si existe un histórico
       const cachedCounts = Storage.get(`gravity_cache_asistentes_${escuadronActivo?.id}`);
       const cachedDetalle = Storage.get(`gravity_cache_det_asistentes_${escuadronActivo?.id}`);
       if (cachedCounts) try { setAsistenciasBoveda(JSON.parse(cachedCounts)); } catch(e){}
       if (cachedDetalle) try { setAsistentesBovedaDetalle(JSON.parse(cachedDetalle)); } catch(e){}

       const fetchCounts = async () => {
          const ids = rutasClubArray.map(r => r.id);
          const { data: rawAsistentes } = await supabase.from('asistentes_rutas').select('*').in('ruta_id', ids);
          
          if (rawAsistentes) {
             const counts: Record<string, number> = {};
             const detalle: Record<string, any[]> = {};
             
             // Traer avatars y datos de usuarios para los asistentes
             const idsMoteronScan = rawAsistentes.map(a => a.motero_id).filter(id => !!id);
             const { data: usersData } = await supabase.from('usuarios').select('id, avatar_url, nombre').in('id', idsMoteronScan);

             rawAsistentes.forEach(row => {
               counts[row.ruta_id] = (counts[row.ruta_id] || 0) + 1;
               
               if (!detalle[row.ruta_id]) detalle[row.ruta_id] = [];
               const uInfo = usersData?.find(u => u.id === row.motero_id);
               detalle[row.ruta_id].push({
                 ...row,
                 avatar_url: uInfo?.avatar_url,
                 nombre: uInfo?.nombre || row.nombre
               });
             });
             
             setAsistenciasBoveda(counts);
             setAsistentesBovedaDetalle(detalle);
             
             // Guardar en la Sombra de Datos
             Storage.set(`gravity_cache_asistentes_${escuadronActivo?.id}`, JSON.stringify(counts));
             Storage.set(`gravity_cache_det_asistentes_${escuadronActivo?.id}`, JSON.stringify(detalle));
          }
       };
       fetchCounts();
    }
  }, [mostrarModalRutasClub, rutasClubArray]);

  const invitadosFiltrados = invitadosParche.filter(inv => {
    const coincideTexto = inv.nombre.toLowerCase().includes(busquedaParche.toLowerCase()) || inv.celular.includes(busquedaParche);
    const coincideOro = filtroOro ? !!inv.esOro : true;
    return coincideTexto && coincideOro;
  });

  const puntosReferidos = invitadosParche.reduce((acc, inv) => acc + (inv.esOro ? 500 : 100), 0);
  const soyCapitan = escuadronActivo?.adminId === Storage.get('gravity_user_id');
  const puntosMesa = soyCapitan ? miembrosEscuadron.reduce((acc, m) => acc + (m.isMe ? 0 : (m.esOro ? 500 : 100)), 0) : 0;
  
  const puntosBrutos = puntosPorAuditoria + puntosReferidos + puntosMesa;
  const totalPuntosGanados = Math.max(0, puntosBrutos - puntosGastados);
  const puntosCongelados = soyOroPuntos ? 0 : totalPuntosGanados;
  const totalPuntos = soyOroPuntos ? totalPuntosGanados : puntosPorAuditoria;

  const [codigoReferido, setCodigoReferido] = useState("");

  React.useEffect(() => {
    const fetchCodigo = async () => {
      let codigo = Storage.get('gravity_codigo') || Storage.get('gravity_mi_codigo_referido');
      if (!codigo) {
        const myId = Storage.get('gravity_user_id');
        if (myId) {
          try {
            const { data } = await supabase.from('usuarios').select('codigo_referido').eq('id', myId).single();
            if (data && data.codigo_referido) {
              codigo = data.codigo_referido;
              Storage.set('gravity_codigo', codigo);
            }
          } catch(e) {}
        }
      }
      
      if (!codigo) {
        const randStr = Math.random().toString(36).substring(2, 6).toUpperCase();
        let prefijo = 'MOTE';
        const aliasRaw = Storage.get('gravity_alias') || Storage.get('gravity_nombre_perfil') || '';
        if (aliasRaw) {
          prefijo = aliasRaw.split(' ')[0].toUpperCase().replace(/[^A-Z]/g, '').substring(0, 5) || 'MOTE';
        }
        codigo = `PIKIS-${prefijo}-${randStr}`;
        Storage.set('gravity_codigo', codigo);
      }
      setCodigoReferido(codigo);
    };
    fetchCodigo();
  }, []);

  const copiarCodigo = () => {
    navigator.clipboard.writeText(codigoReferido);
    setCodigoCopiado(true);
    setTimeout(() => setCodigoCopiado(false), 2000);
  };

  const enviarWhatsAppReferido = () => {
    const texto = `🏍️¡Ey! Descarga *GRAVITY BIKE ¡GRATIS!* para salir a rodar seguro con tu parche. 

🎁 Usa mi código *${codigoReferido}* y gana bonos. 

Descarga la app aquí:
*https://pikishub.com/gravitybike/?ref=${codigoReferido}*`;
    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
  };

  const eliminarInvitado = (id: string) => {
    setDialogoConfirmacion({
      mensaje: '¿Estás seguro de que deseas eliminar a este piloto de tu parche?',
      accion: async () => {
        try {
          // Bajar de la base de datos real
          await supabase.from('amigos_parche').delete().eq('id', id);
          // Ocultar de la interfaz local
          setInvitadosParche(prev => prev.filter(i => i.id !== id));
        } catch (error) {
          console.error("Error borrando el referido:", error);
        }
        setDialogoConfirmacion(null);
      }
    });
  };

  const enviarBroadcastParche = async () => {
    if (!mensajeBroadcast.trim()) return;
    if (invitadosParche.length === 0) {
      alert("No tienes integrantes en tu Parche para enviar mensajes.");
      return;
    }
    
    setEnviandoBroadcast(true);
    const localId = Storage.get('gravity_user_id');
    const userObj = JSON.parse(Storage.get('gravity_user') || '{}');
    
    try {
        const notificaciones = invitadosParche.map(inv => ({
            emisor_id: localId,
            emisor_nombre: userObj.nombre || 'Capitán de Parche',
            receptor_id: inv.celular,
            mensaje: mensajeBroadcast.trim(),
            leido: false
        }));
        
        await supabase.from('notificaciones_inapp').insert(notificaciones);
        alert("📢 Transmisión Masiva In-App enviada al parche exitosamente.");
        setMostrarBroadcast(false);
        setMensajeBroadcast('');
    } catch(e) {
        console.error(e);
        alert("Hubo un error al transmitir el mensaje.");
    }
    setEnviandoBroadcast(false);
  };

  const fetchEscuadronActivo = async () => {
    const localId = Storage.get('gravity_user_id');
    if (!localId) return;
    
    // 1. Verificar si el usuario ya está en un escuadrón (Resiliente a duplicados)
    const { data: miembros } = await supabase.from('miembros_escuadron').select('escuadron_id').eq('motero_id', localId).limit(1);
    const miembroData = miembros && miembros.length > 0 ? miembros[0] : null;
    
    if (miembroData) {
       // 2. Traer info principal del escuadrón
       const { data: escuadronData } = await supabase.from('escuadrones').select('*').eq('id', miembroData.escuadron_id).maybeSingle();
       if (escuadronData) {
          setEscuadronActivo({
             id: escuadronData.id,
             nombre: escuadronData.nombre,
             codigo: escuadronData.codigo_corto,
             adminId: escuadronData.capitan_id
          } as any);

           // Extraer rutas del club
           let rtClub = [];
           if (escuadronData.rutas_club) {
               rtClub = typeof escuadronData.rutas_club === 'string' ? JSON.parse(escuadronData.rutas_club) : escuadronData.rutas_club;
           }
           setRutasClubArray(rtClub);
          
          // 3. Traer a todos los miembros de ese escuadrón
          const { data: todosMiembros } = await supabase.from('miembros_escuadron').select('motero_id').eq('escuadron_id', escuadronData.id);
          if (todosMiembros) {
             const userIds = todosMiembros.map((m: any) => m.motero_id);
             
             // 4. Extraer listado de motos y kilometraje de los miembros
             const { data: motos, error: motosErr } = await supabase.from('vehiculos').select('id, usuario_id, apodo, km_actual').in('usuario_id', userIds);
             
             // 4.1 Traer celulares, nombres reales, suscripcion y AVATAR
             const { data: infoUsuarios } = await supabase.from('usuarios').select('id, celular, nombre, es_oro, avatar_url').in('id', userIds);
             
             const capitanInfo = infoUsuarios?.find((u: any) => u.id === escuadronData.capitan_id);
             const clubEsPremium = capitanInfo?.es_oro || false;
             const clubSaturado = userIds.length > 3 && !clubEsPremium && localId === escuadronData.capitan_id;
             
             setEscuadronActivo(prev => prev ? { ...prev, isPremium: clubEsPremium, isSaturated: clubSaturado } : prev);
             
             const localUserStr = Storage.get('gravity_user');
             let nameObj = null;
             try { nameObj = localUserStr ? JSON.parse(localUserStr).nombre : null; } catch(e) {}
             const miNombreReal = nameObj ? nameObj.split(' ')[0] : 'JORGE ESPITIA';
             
             // Extraer mis métricas locales
             let misKmsLocales = 0;
             try {
                const metricasStr = Storage.get('gravity_metricas');
                const metricasObj = metricasStr ? JSON.parse(metricasStr) : {};
                const misMotosLocales = motos?.filter(m => m.usuario_id === localId) || [];
                // Sumar todos los KMS o elegir la de mayor KM
                misMotosLocales.forEach(m => {
                   if (metricasObj[m.id]?.km) misKmsLocales += metricasObj[m.id].km;
                });
             } catch(e) {}
             
             // 5. Armar Ranking
             const ranking = userIds.map((uid: string) => {
                 const miMoto = motos?.find((m: any) => m.usuario_id === uid);
                 const infoU = infoUsuarios?.find((u: any) => u.id === uid);
                 const esYo = uid === localId;
                 const esAdmin = uid === escuadronData.capitan_id;
                 
                 let suNombre = "Piloto " + (uid?.substring(0,4) || 'XXXX').toUpperCase();
                 if (infoU && infoU.nombre) suNombre = infoU.nombre.split(' ')[0].toUpperCase();
                 
                 let misMotosGlobales = motos?.filter((m: any) => m.usuario_id === uid) || [];
                 let kmTotal = 0;
                 misMotosGlobales.forEach((m: any) => { kmTotal += (Number(m.km_actual) || 0); });
                 
                 // Para el usuario local, usar las métricas guardadas si aún no han subido al server o son más recientes
                 if (esYo && misKmsLocales > kmTotal) kmTotal = misKmsLocales;
                 
                 return {
                    id: uid,
                    alias: esYo ? `${miNombreReal.toUpperCase()} ${esAdmin ? '(LÍDER)' : '(TÚ)'}` : suNombre,
                    moto: miMoto && miMoto.apodo ? miMoto.apodo : (esYo ? 'Tu Moto' : 'Moto Oculta'),
                    kms: kmTotal, 
                    celular: infoU?.celular || '',
                    esOro: infoU?.es_oro || false,
                    avatarUrl: infoU?.avatar_url,
                    isMe: esYo
                 };
             });
             
             // Ordenar por Kilometros de mayor a menor
             ranking.sort((a, b) => b.kms - a.kms);
             
             // Cargar historial de chat
             const { data: chdata } = await supabase.from('chat_escuadrones').select('*').eq('escuadron_id', escuadronData.id).order('fecha', { ascending: true }).limit(50);
             if (chdata) { setMensajesChat(chdata); setTimeout(() => chatScrollRef.current?.scrollIntoView(), 100); }
             
             setMiembrosEscuadron(ranking);
          }
       }
    } else {
        setEscuadronActivo(null);
        
        // Auto-curación para Capitanes huérfanos de membresía (debido a bloqueos RLS pasados)
        try {
           const { data: capSquads } = await supabase.from('escuadrones').select('*').eq('capitan_id', localId).limit(1);
           const escuadronComoCapitan = capSquads && capSquads.length > 0 ? capSquads[0] : null;
           if (escuadronComoCapitan) {
              console.log("Capitán huérfano detectado, auto-creando membresía...");
              await supabase.from('miembros_escuadron').insert([{ escuadron_id: escuadronComoCapitan.id, motero_id: localId }]);
              setTimeout(fetchEscuadronActivo, 500);
           }
        } catch (e) {
           console.error("Error en auto-curacion de capitan:", e);
        }
     }
  };

  React.useEffect(() => {
     fetchEscuadronActivo();

     // Polling en caliente cada 10 segundos para sincronizar el ranking, los kilómetros y miembros del club
     const rankingInterval = setInterval(() => {
        fetchEscuadronActivo();
     }, 10000);

     return () => clearInterval(rankingInterval);
  }, []);
  
     React.useEffect(() => {
      if (escuadronActivo && (escuadronActivo as any).id) {
         const channel = supabase.channel(`chat_escuadron_${(escuadronActivo as any).id}`)
            .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'chat_escuadrones', filter: `escuadron_id=eq.${(escuadronActivo as any).id}` }, payload => {
                setMensajesChat(prev => {
                   const existsIndex = prev.findIndex(m => m.mensaje === payload.new.mensaje && m.emisor_id === payload.new.emisor_id && (!m.id || Math.abs(new Date(m.fecha).getTime() - new Date(payload.new.fecha).getTime()) < 10000));
                   if (existsIndex !== -1) {
                      const newArr = [...prev];
                      newArr[existsIndex] = payload.new;
                      return newArr;
                   }
                   return [...prev, payload.new];
                });
                setTimeout(() => chatScrollRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
            })
            .subscribe();
            
         return () => { supabase.removeChannel(channel); }
      }
   }, [escuadronActivo ? (escuadronActivo as any).id : null]);

   // Fallback de autocuración: Polling periódico cada 5 segundos para asegurar sincronización total del chat
   React.useEffect(() => {
      let interval: any;
      if (escuadronActivo && (escuadronActivo as any).id) {
         interval = setInterval(async () => {
            try {
               const { data: chdata } = await supabase
                  .from('chat_escuadrones')
                  .select('*')
                  .eq('escuadron_id', (escuadronActivo as any).id)
                  .order('fecha', { ascending: true })
                  .limit(50);
               if (chdata) {
                  setMensajesChat(chdata);
               }
            } catch (err) {
               console.warn("Error en polling de chat:", err);
            }
         }, 5000);
      }
      return () => { if (interval) clearInterval(interval); };
   }, [escuadronActivo ? (escuadronActivo as any).id : null]);
  
     const enviarMensajeChat = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!nuevoMensaje.trim() || !escuadronActivo) return;
      
      const miTexto = nuevoMensaje.trim();
      setNuevoMensaje(""); // Optimistic clear
      
      const localId = Storage.get('gravity_user_id');
      const localUserStr = Storage.get('gravity_user');
      let miNombre = "Piloto";
      try {
         if (localUserStr) {
            const parsed = JSON.parse(localUserStr);
            miNombre = parsed.nombre?.split(' ')[0] || "Piloto";
         }
      } catch(e) {}
      
            const msgObj = {
         escuadron_id: (escuadronActivo as any).id,
         emisor_id: localId,
         emisor_nombre: miNombre,
         mensaje: miTexto,
         fecha: new Date().toISOString()
      };

      // Optimistic UI Update (Aparece al instante sin esperar WebSocket)
      setMensajesChat(prev => {
        // Evitar duplicados si el websocket llega muy rápido
        if (prev.some(m => m.mensaje === miTexto && m.emisor_id === localId && (new Date(m.fecha).getTime() > Date.now() - 5000))) return prev;
        return [...prev, msgObj as any];
      });
      setTimeout(() => chatScrollRef.current?.scrollIntoView({ behavior: 'smooth' }), 50);

      const { error: insErr } = await supabase.from('chat_escuadrones').insert([msgObj]);
      if (insErr) {
         console.error("Error al enviar mensaje de chat:", insErr);
         alert("⚠️ No se pudo transmitir tu mensaje: " + (insErr.message || JSON.stringify(insErr)));
         // Volver a poner el texto si falló
         setNuevoMensaje(miTexto);
      }
   };
  
  const enviarUbicacionGrupo = () => {
     if ((escuadronActivo as any).isSaturated) return;
     if (!navigator.geolocation) return alert('GPS no soportado');
     navigator.geolocation.getCurrentPosition(async (pos) => {
        const link = `https://www.google.com/maps?q=${pos.coords.latitude},${pos.coords.longitude}`;
        const localId = Storage.get('gravity_user_id');
        const localUserStr = Storage.get('gravity_user');
        let miNombre = "Piloto";
        try {
           if (localUserStr) {
              const parsed = JSON.parse(localUserStr);
              miNombre = parsed.nombre?.split(' ')[0] || "Piloto";
           }
        } catch(e) {}
        
        const msgObj = {
           escuadron_id: (escuadronActivo as any).id,
           emisor_id: localId,
           emisor_nombre: miNombre,
           mensaje: `📍 Mi ubicación de Ruta: ${link}`
        };
        await supabase.from('chat_escuadrones').insert([msgObj]);
     }, () => {
        setDialogoConfirmacion({
           titulo: "MESA DE CONTROL",
           mensaje: "⚠️ Tu frecuencia de GPS está bloqueada. Pulsa el botón para solicitar permiso de transmisión a la Mesa Redonda.",
           accion: () => setDialogoConfirmacion(null),
           soloAceptar: true,
           color: 'amber',
           cerrable: true
        });
     });
  };

  const enviarUbicacionDirecta = (phone: string) => {
     if (!navigator.geolocation) return alert('GPS no soportado');
     navigator.geolocation.getCurrentPosition((pos) => {
        const link = `https://www.google.com/maps?q=${pos.coords.latitude},${pos.coords.longitude}`;
        const texto = `📍 Copia del Líder: Esta es mi ubicación actual de ruta: ${link}`;
        window.open(`https://wa.me/57${phone}?text=${encodeURIComponent(texto)}`, '_blank');
      }, () => {
         setDialogoConfirmacion({
            titulo: "MESA DE CONTROL",
            mensaje: "⚠️ Tu frecuencia de GPS está bloqueada. Pulsa el botón para solicitar permiso de transmisión a la Mesa Redonda.",
            color: 'amber',
            soloAceptar: true,
            accion: () => setDialogoConfirmacion(null)

         });
      });
  };

  const crearEscuadron = async () => {
    if(!nuevoNombreEscuadron.trim()) return;
    const localId = Storage.get('gravity_user_id');
    if (!localId) return;
    
    setCreandoEscuadron(true);

    // Generador de código corto estilo "ANG-482"
    const shortCode = nuevoNombreEscuadron.trim().substring(0,3).toUpperCase() + '-' + Math.floor(100 + Math.random() * 900);
    
    // Retrieve user's PIN from storage
    let pin = '';
    try {
      const userStr = Storage.get('gravity_user');
      if (userStr) {
        const parsed = JSON.parse(userStr);
        pin = parsed.pin || '';
      }
    } catch (e) {
      console.warn("No se pudo obtener el PIN para crear escuadrón:", e);
    }

    if (!pin) {
      alert("Tu sesión de seguridad no tiene un PIN de acceso activo. Por favor, cierra sesión en tu perfil (menú lateral) y vuelve a ingresar para reactivarlo.");
      setCreandoEscuadron(false);
      return;
    }

    let data: any = null;
    let saveError: any = null;
    let rpcUsado = false;

    try {
      // Modo A: Intentar inserción segura por RPC en base de datos
      const { data: rpcData, error: rpcError } = await supabase.rpc('crear_escuadron_seguro', {
        p_capitan_id: localId,
        p_pin: pin,
        p_nombre: nuevoNombreEscuadron.trim().toUpperCase(),
        p_codigo_corto: shortCode
      });

      if (rpcError) {
        // Fallback: Si no existe el RPC, intentamos directo por PostgREST API (Modo B)
        if (rpcError.code === 'PGRST202' || rpcError.code === 'PGRST501' || rpcError.code === '42883') {
          console.log("RPC 'crear_escuadron_seguro' no existe. Usando inserción directa...");
          const { data: directData, error: directError } = await supabase.from('escuadrones').insert([{ 
             nombre: nuevoNombreEscuadron.trim().toUpperCase(), 
             codigo_corto: shortCode, 
             capitan_id: localId 
          }]).select().single();

          if (directError) {
            saveError = directError;
          } else {
            data = directData;
          }
        } else {
          saveError = rpcError;
        }
      } else {
        // El RPC devuelve el UUID de la fila creada
        data = { id: rpcData };
        rpcUsado = true;
      }
    } catch (err: any) {
      saveError = err;
    }

    if (data) {
       if (!rpcUsado) {
         try {
           // Solo si NO se usó RPC, auto-unir al Capitán al escuadrón recién creado mediante inserción directa
           const { error: mError } = await supabase.from('miembros_escuadron').insert([{ 
             escuadron_id: data.id, 
             motero_id: localId 
           }]);
           
           if (mError) {
             console.error("Error auto-uniendo capitán:", mError);
             alert(`Escuadrón creado con éxito, pero hubo un problema al agregarte como Capitán.\n\nDetalle: ${mError.message}\n\nAsegúrate de habilitar las políticas de inserción para la tabla 'miembros_escuadron' en tu panel de Supabase.`);
           }
         } catch (e) {
           console.error(e);
         }
       }
       fetchEscuadronActivo();
    } else {
       console.error("Error BD al crear escuadrón:", saveError);
       alert(`Atención Gravity Bike: No se pudo erigir la mesa.\n\nCódigo de Error: ${saveError?.code || 'Desconocido'}\nDetalle: ${saveError?.message || JSON.stringify(saveError)}\n\nSi es un error RLS (42501), debes habilitar las directivas de inserción para usuarios 'anon' en la tabla 'escuadrones' desde tu consola de Supabase.`);
    }

    setCreandoEscuadron(false);
  };

  const unirseEscuadron = async () => {
    if(!codigoUnirse.trim()) return;
    const localId = Storage.get('gravity_user_id');
    if (!localId) return;

    const { data: esc } = await supabase.from('escuadrones').select('id').eq('codigo_corto', codigoUnirse.toUpperCase()).maybeSingle();
    if (esc) {
       const { error } = await supabase.from('miembros_escuadron').insert([{ escuadron_id: esc.id, motero_id: localId }]);
       if(error) alert("Ya perteneces a un escuadrón.");
       fetchEscuadronActivo();
    } else {
       alert("El Código de Escuadrón ingresado no existe.");
    }
  };

  const eliminarMiembroEscuadron = (idToKick: string) => {
    setDialogoConfirmacion({
      mensaje: '¿Estás seguro de expulsar a este piloto de la Mesa Redonda?',
      accion: async () => {
         if (escuadronActivo && (escuadronActivo as any).id) {
            await supabase.from('miembros_escuadron').delete().eq('escuadron_id', (escuadronActivo as any).id).eq('motero_id', idToKick);
            fetchEscuadronActivo();
         }
         setDialogoConfirmacion(null);
      }
    });
  };

  const compartirClaveWhatsApp = () => {
    if (!escuadronActivo) return;
    const texto = `🔥 Únete a mi *Parche Oficial [ ${escuadronActivo.nombre} ]* en *GRAVITY BIKE.*\n\n*Entra al menú PARCHE, la Mesa Redonda y usa este Código de Acceso:*\n👉 *${escuadronActivo.codigo}*\n\nDescarga la app aquí:\nhttps://pikishub.com/gravitybike/`;
    
    if (navigator.share) {
        navigator.share({
            title: 'Mesa de Control GRAVITY BIKE',
            text: texto,
        }).catch(() => {
            window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
        });
    } else {
        window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
    }
  };

  const abandonarEscuadron = async () => {
     const localId = Storage.get('gravity_user_id');
     if (escuadronActivo && (escuadronActivo as any).id) {
         setDialogoConfirmacion({
           mensaje: '¿Estás seguro de abandonar este escuadrón para siempre?',
           accion: async () => {
             await supabase.from('miembros_escuadron').delete().eq('escuadron_id', (escuadronActivo as any).id).eq('motero_id', localId);
             setEscuadronActivo(null);
             setModoEscuadron('decision');
             setDialogoConfirmacion(null);
           }
         });
     }
  };
  const editarNombreEscuadron = () => {
    const isAdmin = escuadronActivo?.adminId === Storage.get('gravity_user_id');
    if (!isAdmin) return;
    setDialogoInputNombre(escuadronActivo?.nombre || "");
  };

  const guardarNuevoNombreEscuadron = async (e: React.FormEvent) => {
     e.preventDefault();
     if (dialogoInputNombre === null || !dialogoInputNombre.trim()) {
        setDialogoInputNombre(null);
        return;
     }
     const nuevo = dialogoInputNombre.trim().toUpperCase();
     const { error } = await supabase.from('escuadrones').update({ nombre: nuevo }).eq('id', (escuadronActivo as any).id);
     if (!error) {
        fetchEscuadronActivo();
     } else {
        alert("Error al actualizar. Posible nombre duplicado.");
     }
     setDialogoInputNombre(null);
  };

  const eliminarEscuadronCompleto = () => {
     setDialogoConfirmacion({
         mensaje: '🚨 PELIGRO: ¿Estás 100% seguro de destruir todo el Escuadrón? Se expulsarán todos los miembros y se perderá su código.',
         accion: async () => {
             await supabase.from('escuadrones').delete().eq('id', (escuadronActivo as any).id);
             setEscuadronActivo(null);
             setModoEscuadron('decision');
             setDialogoConfirmacion(null);
         }
     });
  };

  const procesarCanjeORO = async () => {
     if (procesandoCanje) return;
     if (soyOroPuntos) {
         setDialogoConfirmacion({
             titulo: "LÍDER ORO ACTIVO",
             mensaje: "👑 Ya eres un Líder ORO inquebrantable. ¡Sigue dominando la vía!",
             color: 'emerald',
             soloAceptar: true,
             accion: () => setDialogoConfirmacion(null)
         });
         return;
     }
     if (totalPuntosGanados < 30000) {
         setDialogoConfirmacion({
             titulo: "PUNTOS INSUFICIENTES",
             mensaje: "⚠️ Requieres 30.000 Puntos limpios para ascender al rango ORO.\n\nSigue invitando referidos o evaluando talleres para sumar más rápido.",
             color: 'amber',
             soloAceptar: true,
             accion: () => setDialogoConfirmacion(null)
         });
         return;
     }
     
     setProcesandoCanje(true);
     const localId = Storage.get('gravity_user_id');
     try {
        const url = `https://pikishub.com/.netlify/functions/canjear-puntos?id=${localId}&puntosAGastar=30000&esOro=true`;
        const res = await fetch(url);
        const data = await res.json();
        if (data.success) {
            setDialogoConfirmacion({
                titulo: "ASCENSO EXITOSO",
                mensaje: "🎉 ¡Recompensa Reclamada con Éxito!\n\nAcabas de blindarte en ORO, la hermandad de Gravity Bike te rinde homenaje.",
                color: 'emerald',
                soloAceptar: true,
                accion: () => setDialogoConfirmacion(null)
            });
            setSoyOroPuntos(true);
            setPuntosGastados(data.nuevoSaldoGastado);
            setMostrarCanje(false);
        } else {
            setDialogoConfirmacion({
                titulo: "FALLO DE ASCENSO",
                mensaje: "❌ ERROR: " + (data.error || "No se pudo procesar el canje."),
                color: 'red',
                soloAceptar: true,
                accion: () => setDialogoConfirmacion(null)
            });
        }
     } catch(e) {
        setDialogoConfirmacion({
            titulo: "FALLO DE SEÑAL",
            mensaje: "📡 MESA DE CONTROL: Error de conexión al reclamar la suscripción. Verifica tu internet e intenta de nuevo.",
            color: 'red',
            soloAceptar: true,
            accion: () => setDialogoConfirmacion(null)
        });
     } finally {
        setProcesandoCanje(false);
     }
  };

  const procesarCanjeSIMIT = async () => {
     if (procesandoCanje) return;
      if (totalPuntosGanados < 3000) {
         return setDialogoConfirmacion({
            titulo: "PUNTOS INSUFICIENTES",
            mensaje: "⚠️ MESA DE CONTROL: Requieres 3.000 Puntos limpios para solicitar la validación SIMIT. ¡Sigue invitando referidos para sumar!",
            color: 'amber',
            soloAceptar: true,
            accion: () => setDialogoConfirmacion(null)
         });
      }
     
     setMostrarFormSimit(true);
  };

  const ejecutarCanjeSIMIT = async () => {
     if (!formSimit.nombre || !formSimit.cedula || !formSimit.placa) {
         setDialogoConfirmacion({
            titulo: "DATOS INCOMPLETOS",
            mensaje: "⚠️ MESA DE CONTROL: Por favor, completa el Nombre, Cédula y Placa para generar tu certificado.",
            color: 'amber',
            soloAceptar: true,
            accion: () => setDialogoConfirmacion(null)
         });
         return;
     }

     const ccOk = formSimit.cedula.replace(/\D/g, '');
     const placaOk = formSimit.placa.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
     const nombreOk = formSimit.nombre.toUpperCase().trim();
     
     setProcesandoCanje(true);
     const localId = Storage.get('gravity_user_id');
     try {
        const url = `https://pikishub.com/.netlify/functions/canjear-puntos?id=${localId}&puntosAGastar=3000&esOro=false`;
        const res = await fetch(url);
        const data = await res.json();
        if (data.success) {
            setPuntosGastados(data.nuevoSaldoGastado);
            setMostrarCanje(false);
            setMostrarFormSimit(false);
            
            setDialogoConfirmacion({
                titulo: "CANJE EXITOSO",
                mensaje: "✅ ¡Puntos descontados con éxito!\n\nPresiona el botón para ir a la línea privada de WhatsApp y despachar tu solicitud VIP.",
                color: 'emerald',
                soloAceptar: true,
                accion: () => {
                    const message = `*SOLICITUD VIP SIMIT* 🚨⚖️\n\nHola Equipo Pikis.\nAcabo de realizar un Canje Exitoso quemando *3.000 Puntos* en la App para solicitar mi Paz y Salvo SIMIT Oficial.\n\n*Documento:* ${ccOk}\n*Placa:* ${placaOk}\n*A Nombre de:* ${nombreOk}\n\nQuedo atento a la validación. ¡Gracias!`;
                    window.open(`https://wa.me/573013310246?text=${encodeURIComponent(message)}`, '_blank');
                    setDialogoConfirmacion(null);
                    setFormSimit({ nombre: '', cedula: '', placa: '' });
                }
            });
        } else {
            setDialogoConfirmacion({
                titulo: "ERROR DE CANJE",
                mensaje: "❌ MESA DE CONTROL: " + (data.error || "No se pudo procesar el pase VIP."),
                color: 'red',
                soloAceptar: true,
                accion: () => setDialogoConfirmacion(null)
            });
        }
     } catch(e) {
        setDialogoConfirmacion({
            titulo: "FALLO DE SEÑAL",
            mensaje: "📡 MESA DE CONTROL: Error de conexión. No pudimos contactar al servidor VIP. Verifica tu internet e intenta de nuevo.",
            color: 'red',
            soloAceptar: true,
            accion: () => setDialogoConfirmacion(null)
        });
     } finally {
        setProcesandoCanje(false);
     }
  };

  const expulsarDeBoveda = async (rutaId: string) => {
     setDialogoConfirmacion({
       mensaje: "¿Seguro que deseas expulsar esta misión de la Bóveda del Escuadrón?\n(No se borrará del mapa público, solo se removerá de tu club)",
       accion: async () => {
          const nuevasRutas = rutasClubArray.filter(r => r.id !== rutaId);
          setRutasClubArray(nuevasRutas);
          if (escuadronActivo) {
             await supabase.from('escuadrones').update({ rutas_club: nuevasRutas }).eq('id', escuadronActivo.id);
          }
          setDialogoConfirmacion(null);
       }
     });
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col relative bg-transparent pb-24"
    >
      {modoEspejo === 'vip' ? (
        <>
          {/* BANNER VIP GRAVITY BIKE */}
          <div className="w-full h-40 mb-6 rounded-2xl overflow-hidden border border-white/10 shadow-[0_10px_30px_rgba(0,0,0,0.5)] relative bg-black">
             <img src={`${import.meta.env.BASE_URL}banner_vip.jpg`} alt="Gravity Bike VIP" className="w-full h-full object-cover opacity-90" />
             <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent pointer-events-none" />
             <div className="absolute bottom-3 right-3 opacity-50">
                <Crown className="w-8 h-8 text-gold-cert" />
             </div>
          </div>

          <div className="flex items-center gap-3 mb-6">
            <Crown className="w-5 h-5 text-gold-cert flex-shrink-0 filter drop-shadow-[0_0_10px_rgba(251,191,36,0.5)]" />
            <h2 className="text-lg font-black text-white uppercase tracking-wider leading-none">Zona VIP<br/><span className="text-[10px] text-slate-400">Recompensas y Referidos</span></h2>
          </div>

          {/* 0. SISTEMA DE PUNTOS / REPUTACIÓN */}
          <div className={`${puntosCongelados > 0 ? 'bg-gradient-to-br from-slate-900 to-black border-red-500/30 shadow-[0_0_20px_rgba(239,68,68,0.1)]' : 'bg-gradient-to-br from-[#1e293b] to-black border-yellow-500/30 shadow-[0_0_20px_rgba(234,179,8,0.15)]'} border rounded-2xl p-3.5 mb-3 relative overflow-hidden shrink-0 flex items-center justify-between`}>
            <Crown className={`absolute -right-4 -bottom-4 w-24 h-24 ${puntosCongelados > 0 ? 'text-red-500/5' : 'text-yellow-500/5'} pointer-events-none`} />
            
            <div className="relative z-10 flex flex-col">
              <span className={`text-[10px] font-black uppercase tracking-widest leading-none mb-1 ${puntosCongelados > 0 ? 'text-slate-300' : 'text-yellow-500'}`}>Reputación VIP</span>
              
              <div className="flex items-end gap-1.5 mt-0.5 mb-2 relative">
                <span className={`text-2xl font-black tabular-nums leading-none tracking-tight ${puntosCongelados > 0 ? 'text-white/40 line-through' : 'text-white drop-shadow-[0_0_15px_rgba(234,179,8,0.5)]'}`}>{totalPuntosGanados}</span>
                {puntosCongelados > 0 ? (
                   <span className="text-red-500 text-[11px] font-black uppercase whitespace-nowrap animate-pulse pb-0.5">+{puntosCongelados} PTS</span>
                ) : (
                   <span className="text-yellow-500 text-[12px] font-bold uppercase pb-0.5">Pts</span>
                )}
                {puntosCongelados > 0 && <div className="absolute -bottom-2.5 left-0 text-[7px] text-red-500/80 font-bold uppercase tracking-wider">Bloqueados</div>}
              </div>
              
              {puntosCongelados > 0 ? (
                <button 
                  onClick={() => setMostrarCanje(true)}
                  className="bg-red-600 text-white font-black text-[9px] uppercase tracking-wider py-1.5 px-3 rounded-lg flex items-center justify-center gap-1.5 shadow-[0_0_15px_rgba(239,68,68,0.4)] hover:bg-red-500 transition-all w-fit animate-pulse mt-1"
                >
                  <Crown className="w-3.5 h-3.5" /> Cobrar Puntos
                </button>
              ) : (
                <button 
                  onClick={() => setMostrarCanje(true)}
                  className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-yellow-950 font-black text-[9px] uppercase tracking-wider py-1.5 px-3 rounded-lg flex items-center justify-center gap-1.5 shadow-[0_0_10px_rgba(234,179,8,0.3)] hover:brightness-110 active:scale-95 transition-all w-fit"
                >
                  <Gift className="w-3.5 h-3.5" /> Canjear Puntos
                </button>
              )}
            </div>
            
            <div className={`relative z-10 text-right bg-black/50 p-2.5 rounded-xl border flex-shrink-0 ${puntosCongelados > 0 ? 'border-red-500/20' : 'border-yellow-500/10'} shadow-inner flex flex-col justify-center gap-1.5`}>
              <p className="text-slate-200 text-[9px] font-bold uppercase tracking-wider leading-none whitespace-nowrap">
                <span className={`${puntosCongelados > 0 ? 'text-white' : 'text-yellow-500'} font-black`}>100 PTS</span> <span className="text-[7px] text-slate-500">x</span> GRATIS
              </p>
              <div className="w-full h-px bg-white/5"></div>
              <p className="text-slate-200 text-[9px] font-bold uppercase tracking-wider leading-none whitespace-nowrap">
                <span className={`${puntosCongelados > 0 ? 'text-white' : 'text-yellow-500'} font-black`}>500 PTS</span> <span className="text-[7px] text-slate-500">x</span> PRO <Crown className={`w-2.5 h-2.5 inline-block ${puntosCongelados > 0 ? 'text-slate-400' : 'text-yellow-500'} mb-0.5`}/>
              </p>
              <div className="w-full h-px bg-white/5"></div>
              <p className="text-slate-200 text-[9px] font-bold uppercase tracking-wider leading-none whitespace-nowrap">
                <span className={`${puntosCongelados > 0 ? 'text-white' : 'text-yellow-500'} font-black`}>1 PT</span> <span className="text-[7px] text-slate-500">x</span> $1K MXN
              </p>
            </div>
          </div>

          {/* 1. BANNER COMERCIAL: INVITA Y GANA (MODO LOBOS SOLITARIOS) */}
          <div className="bg-gradient-to-r from-green-600/20 to-emerald-900/40 border border-green-500/30 rounded-2xl p-3 mb-4 relative overflow-hidden shadow-[0_5px_15px_rgba(16,185,129,0.15)] shrink-0">
            <div className="absolute top-0 right-0 p-2 opacity-20 pointer-events-none">
              <Users className="w-16 h-16 text-green-400" />
            </div>
            <div className="relative z-10 flex flex-col h-full">
              <div className="flex justify-between items-start mb-1.5">
                <h3 className="text-white font-black text-[13px] flex items-center gap-2"><Users className="w-3.5 h-3.5 text-green-400" /> INVITACIÓN SENCILLA</h3>
                <button 
                  onClick={() => setMostrarParche(true)}
                  className="-mt-1 bg-green-500/20 text-green-400 border border-green-500/40 px-2.5 py-1 rounded-full text-[9px] font-black uppercase flex items-center gap-1.5 shadow-[0_0_10px_rgba(74,222,128,0.2)] hover:bg-green-500/30 transition-colors"
                >
                  Mis Referidos ({invitadosParche.length})
                </button>
              </div>
              <p className="text-slate-300 text-[10px] leading-snug font-medium pr-1 mb-2">
                Perfecto si solo ruedas con uno o dos amigos. Pásales tu código para ganar puntos y estar conectados en las alertas de S.O.S.
              </p>
              
              <div className="flex items-center gap-2 mt-auto">
                <div className="bg-black/50 border border-white/10 rounded-xl px-2.5 py-1.5 flex items-center justify-between flex-1">
                  <span className="text-green-400 font-mono font-bold tracking-widest text-[11px]">{codigoReferido}</span>
                  <button onClick={copiarCodigo} className="text-slate-400 hover:text-white transition-colors">
                    {codigoCopiado ? <CheckCircle className="w-3.5 h-3.5 text-green-500" /> : <Copy className="w-3 h-3" />}
                  </button>
                </div>
                <button 
                  onClick={enviarWhatsAppReferido}
                  className="bg-green-500 hover:bg-green-400 text-green-950 px-2.5 py-1.5 rounded-xl flex items-center gap-1.5 font-bold text-[11px] transition-colors whitespace-nowrap"
                >
                  <MessageCircle className="w-3.5 h-3.5" /> Enviar
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {!escuadronActivo ? (
            <div className="flex-1 flex flex-col justify-center gap-5 max-w-sm mx-auto w-full pt-4">
              <div className="flex items-center gap-3 mb-2 justify-center">
                <Shield className="w-8 h-8 text-indigo-500 drop-shadow-[0_0_15px_rgba(99,102,241,0.8)]" /> 
                <h2 className="text-xl font-black text-white uppercase tracking-wider leading-none">Mi Escuadra<br/><span className="text-[12px] text-slate-400">Club Social</span></h2>
              </div>

              {modoEscuadron === 'decision' && (
                 <>
                   <div className="text-center mb-4">
                      <Trophy className="w-12 h-12 text-slate-700 mx-auto mb-2" />
                      <h3 className="text-slate-300 text-xs font-bold uppercase tracking-wider mb-1">Aún no perteneces a nada</h3>
                      <p className="text-slate-500 text-[10px]">Un Escuadrón te permite competir en kilometraje con tus amigos.</p>
                   </div>
                   <button onClick={() => setModoEscuadron('fundar')} className="group w-full bg-gradient-to-r from-indigo-600 to-indigo-900 border border-indigo-400/50 p-5 rounded-3xl text-left relative overflow-hidden shadow-[0_10px_30px_rgba(99,102,241,0.2)] hover:shadow-[0_10px_40px_rgba(99,102,241,0.4)] transition-all">
                      <Shield className="absolute right-[-20px] bottom-[-20px] w-28 h-28 text-indigo-400/10 group-hover:text-indigo-400/20 transition-colors transform group-hover:scale-110" />
                      <h4 className="text-white font-black text-base mb-1 flex items-center gap-2 uppercase tracking-wide"><Crown className="w-4 h-4 text-indigo-300" /> FUNDAR ESCUADRÓN</h4>
                      <p className="text-indigo-200/60 text-[11px] font-medium relative z-10 max-w-[80%]">Crea tu propio parche. Serás el Capitán con poder de administración local.</p>
                   </button>

                   <div className="flex items-center gap-3 my-1 opacity-50">
                      <div className="h-px bg-white/20 flex-1"></div>
                      <span className="text-white text-[8px] font-black uppercase tracking-widest">Ó SÚMATE A UNO</span>
                      <div className="h-px bg-white/20 flex-1"></div>
                   </div>

                   <button onClick={() => setModoEscuadron('unirse')} className="group w-full bg-slate-800/50 border border-slate-700 p-5 rounded-3xl text-left relative overflow-hidden hover:bg-slate-800 hover:border-slate-500 transition-all">
                      <Zap className="absolute right-[-10px] bottom-[-10px] w-20 h-20 text-slate-600/20 group-hover:text-slate-500/30 transition-colors transform group-hover:-rotate-12" />
                      <h4 className="text-white font-black text-base mb-1 flex items-center gap-2 uppercase tracking-wide"><Users className="w-4 h-4 text-slate-400" /> INYECTAR CÓDIGO</h4>
                      <p className="text-slate-400 text-[11px] font-medium relative z-10">¿Tu parche ya existe? Ingresa el código serial para aparecer en su tablero.</p>
                   </button>
                 </>
              )}

              {modoEscuadron === 'fundar' && (
                 <div className="bg-indigo-950/40 border border-indigo-500/30 p-5 rounded-3xl">
                    <h4 className="text-white font-black text-base mb-1 uppercase tracking-wider">Nombre del Club Oficial</h4>
                    <p className="text-slate-400 text-[10px] mb-4">Elige bajo qué estandarte correrán.</p>
                    <input 
                      type="text" 
                      placeholder="Ej: Ángeles del Asfalto"
                      value={nuevoNombreEscuadron}
                      onChange={e => setNuevoNombreEscuadron(e.target.value.toUpperCase())}
                      className="w-full bg-black/50 border border-indigo-500/40 text-indigo-100 font-black text-center text-base p-3.5 rounded-2xl outline-none focus:border-indigo-400 focus:bg-indigo-900/20 transition-all uppercase mb-3 shadow-inner"
                    />
                    <div className="flex gap-3 mt-4">
                      <button onClick={() => setModoEscuadron('decision')} className="flex-1 py-2 text-slate-400 hover:text-white font-bold text-xs uppercase transition-colors">Volver</button>
                      <button 
                        onClick={crearEscuadron} 
                        disabled={creandoEscuadron || !nuevoNombreEscuadron.trim()} 
                        className={`flex-[2] py-2 text-white rounded-xl font-black uppercase text-xs tracking-widest transition-all ${creandoEscuadron ? 'bg-slate-700 text-slate-400 cursor-not-allowed opacity-50' : 'bg-indigo-600 hover:bg-indigo-500 shadow-[0_0_20px_rgba(99,102,241,0.5)] active:scale-95'}`}
                      >
                        {creandoEscuadron ? (
                          <span className="flex items-center justify-center gap-1.5">
                            <RefreshCw className="w-3.5 h-3.5 animate-spin" /> Creando...
                          </span>
                        ) : (
                          'Erigir Mesa'
                        )}
                      </button>
                    </div>
                 </div>
              )}

              {modoEscuadron === 'unirse' && (
                 <div className="bg-slate-900/80 border border-slate-700 p-5 rounded-3xl">
                    <h4 className="text-white font-black text-base mb-1 uppercase tracking-wider">Buscar Respaldo</h4>
                    <p className="text-slate-400 text-[10px] mb-4">Pídele al Capitán el código secreto (Ej: ANG-401).</p>
                    <input 
                      type="text" 
                      placeholder="COD-XXXX"
                      value={codigoUnirse}
                      onChange={e => setCodigoUnirse(e.target.value.toUpperCase())}
                      className="w-full bg-black/50 border border-slate-600 text-white font-black text-center font-mono text-lg p-3.5 rounded-2xl outline-none focus:border-white transition-all uppercase mb-3 shadow-inner"
                    />
                    <div className="flex gap-3 mt-4">
                      <button onClick={() => setModoEscuadron('decision')} className="flex-1 py-2 text-slate-400 hover:text-white font-bold text-xs uppercase transition-colors">Volver</button>
                      <button onClick={unirseEscuadron} disabled={!codigoUnirse.trim()} className="flex-[2] py-2 bg-white text-black rounded-xl font-black uppercase text-xs tracking-widest hover:bg-slate-200 active:scale-95 transition-all disabled:opacity-50">Vincularse</button>
                    </div>
                 </div>
              )}
            </div>
          ) : (
            <div className="flex-1 flex flex-col h-full overflow-hidden">
               
               {/* Header Dashboard */}
               <div className="bg-gradient-to-r from-black/80 to-indigo-950/80 border border-indigo-500/30 p-3.5 px-4 rounded-2xl mb-3 flex flex-col shadow-[0_10px_30px_rgba(0,0,0,0.5)] shrink-0">
                  <div className="flex justify-between items-center mb-1">
                     <span className="text-indigo-400 text-[9px] font-black uppercase tracking-widest">Cuartel Activo</span>
                     <button 
                        onClick={() => { setActualizando(true); fetchEscuadronActivo().finally(() => setTimeout(() => setActualizando(false), 500)); }}
                        className={`p-1.5 rounded-full bg-indigo-500/10 hover:bg-indigo-500/30 text-indigo-400 transition-colors ${actualizando ? 'opacity-50' : ''}`}
                        disabled={actualizando}
                        title="Sincronizar Pilotos"
                     >
                        <RefreshCw className={`w-3.5 h-3.5 ${actualizando ? 'animate-spin text-white' : ''}`} />
                     </button>
                  </div>
                  <div className="flex justify-between items-start mb-3">
                     <div className="flex max-w-[80%]">
                       <h3 
                         onClick={escuadronActivo.adminId === Storage.get('gravity_user_id') ? editarNombreEscuadron : undefined} 
                         className={`text-white font-black text-xl uppercase tracking-tighter leading-none break-words ${escuadronActivo.adminId === Storage.get('gravity_user_id') ? 'cursor-pointer hover:text-indigo-300 transition-colors' : ''}`}
                         title={escuadronActivo.adminId === Storage.get('gravity_user_id') ? "Toca para Editar Nombre" : ""}
                       >
                          {escuadronActivo.nombre} {escuadronActivo.adminId === Storage.get('gravity_user_id') && <Edit3 className="inline w-3.5 h-3.5 ml-1 mb-1 text-indigo-400 opacity-60" />}
                       </h3>
                     </div>
                     {escuadronActivo.adminId === Storage.get('gravity_user_id') && escuadronActivo.isPremium && <Crown className="w-5 h-5 text-yellow-500 shrink-0 shadow-lg glow" />}
                  </div>
                  <div className="flex justify-between items-center bg-black/60 p-2 px-3 rounded-xl border border-white/5 box-shadow-inner">
                     <div>
                        <span className="text-slate-500 text-[9px] uppercase font-bold tracking-widest block">Código de Envío</span>
                        <span className="text-indigo-300 font-mono font-bold text-[13px] tracking-widest">{escuadronActivo.codigo}</span>
                     </div>
                     <button onClick={compartirClaveWhatsApp} className="bg-indigo-600/30 hover:bg-indigo-600 text-indigo-300 hover:text-white px-3 py-1.5 rounded-lg text-[10px] font-black uppercase transition-all flex items-center gap-1">
                        <Copy className="w-3 h-3" /> Compartir Clave
                     </button>
                  </div>
               </div>

               {/* Navegación y Vistas */}
               <div className="flex gap-2 mb-4 px-1 shrink-0">
                  <button onClick={() => setMostrarModalRutasClub(true)} className="flex-1 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 rounded-xl text-[10px] font-black uppercase tracking-widest text-white py-2 flex items-center justify-center gap-1.5 shadow-[0_0_15px_rgba(37,99,235,0.4)] active:scale-95 transition-all border border-blue-500/50">
                     <MapPin className="w-4 h-4" /> 📍 Rutas Oficiales
                  </button>
                  <button onClick={() => setMostrarChat(true)} className="flex-1 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-500 hover:to-indigo-600 rounded-xl text-[10px] font-black uppercase tracking-widest text-white py-2 flex items-center justify-center gap-1.5 shadow-[0_0_15px_rgba(79,70,229,0.4)] active:scale-95 transition-all border border-indigo-500/50">
                     <MessageCircle className="w-4 h-4" /> 💬 Chat de Club
                  </button>
               </div>

               {/* Leaderboard Competitivo */}
               <div className="flex items-center justify-between mb-2 px-2 shrink-0">
                  <h4 className="text-white font-black text-[14px] uppercase tracking-wider flex items-center gap-2">
                     <Activity className="w-4 h-4 text-emerald-400" /> Rendimiento Global
                  </h4>
               </div>

               <div className="flex-1 overflow-y-auto space-y-2 pb-8 pr-1">
                  {miembrosEscuadron.sort((a,b) => b.kms - a.kms).map((miembro, index) => {
                     const top3 = index < 3;
                     const isFirst = index === 0;
                     const apagadoDictatorial = !escuadronActivo.isPremium && miembrosEscuadron.length > 3;
                     const isContactRestricted = apagadoDictatorial;
                     
                     const leaderIsFree = apagadoDictatorial;

                     return (
                        <motion.div 
                           key={miembro.id}
                           initial={{ opacity: 0, x: -20 }}
                           animate={{ opacity: 1, x: 0 }}
                           transition={{ delay: index * 0.1 }}
                           className={`flex items-center bg-black border p-2.5 rounded-xl relative overflow-hidden transition-all ${miembro.isMe ? (leaderIsFree ? 'border-slate-500 bg-slate-700/50' : 'border-indigo-500/50 shadow-[0_0_20px_rgba(99,102,241,0.15)] bg-indigo-950/20') : 'border-white/10 hover:border-white/20'}`}
                        >
                           {miembro.isMe && !leaderIsFree && <div className="absolute top-0 right-0 w-2 h-full bg-indigo-50"></div>}
                           {miembro.isMe && leaderIsFree && <div className="absolute top-0 right-0 w-2 h-full bg-slate-300"></div>}
                           

                           {/* Foto de Perfil del Miembro */}
                           <div className="relative shrink-0 mr-3">
                              <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(0,0,0,0.4)] border border-white/10 overflow-hidden">
                              {miembro.avatarUrl ? (
                                 <img src={miembro.avatarUrl} alt={miembro.alias} className="w-full h-full object-cover" />
                              ) : (
                                 <div className={`w-full h-full flex items-center justify-center bg-gradient-to-br ${miembro.isMe ? 'from-indigo-600 to-purple-600' : 'from-slate-700 to-slate-800'}`}>
                                    <span className="text-white font-black text-sm uppercase">{miembro.alias.charAt(0)}</span>
                                 </div>
                              )}
                              </div>
                              
                              <div className={`absolute -bottom-1 -right-0.5 w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-black border-2 border-black shadow-lg z-10 ${leaderIsFree ? 'bg-slate-600 text-slate-200' : isFirst ? 'bg-gradient-to-tr from-yellow-600 to-yellow-400 text-yellow-950 shadow-yellow-500/20' : (!escuadronActivo.isSaturated || top3) ? 'bg-slate-700 text-white' : 'bg-slate-800 text-slate-500'}`}>
                                 #{index + 1}
                              </div>
                           </div>
                           
                           <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-1.5">
                                 <h5 className={`font-black text-[13px] uppercase truncate ${leaderIsFree ? 'text-slate-100 drop-shadow-md' : miembro.isMe ? 'text-indigo-300' : 'text-white'}`}>{miembro.alias}</h5>
                                 {miembro.esOro && <Crown className={`w-3.5 h-3.5 ${leaderIsFree ? 'text-slate-300' : 'text-yellow-500'}`} />}
                              </div>
                              <p className={`text-[9px] font-mono tracking-widest truncate ${leaderIsFree ? 'text-slate-300' : 'text-slate-400'}`}>{miembro.moto}</p>
                           </div>

                           <div className="flex items-center gap-2.5">
                              <div className="text-right">
                                 <span className={`block font-black text-lg leading-none tabular-nums ${leaderIsFree ? 'text-slate-100 drop-shadow-md' : isFirst ? 'text-yellow-400 drop-shadow-[0_0_8px_rgba(234,179,8,0.5)]' : 'text-emerald-400'}`}>{miembro.kms.toLocaleString('es-CO')}</span>
                                 <span className={`text-[9px] uppercase font-bold tracking-widest ${leaderIsFree ? 'text-slate-300' : 'text-slate-500'}`}>KMs</span>
                              </div>
                              
                              {/* Controles del Capitán / WhatsApp */}
                              {miembro.celular && !miembro.isMe && (
                                <div className="flex items-center gap-0.5">
                                   {escuadronActivo.adminId === Storage.get('gravity_user_id') && (
                                      <button disabled={isContactRestricted} onClick={() => enviarUbicacionDirecta(miembro.celular)} title="Mandar GPS Privado" className={`p-1.5 rounded-full transition-colors shrink-0 ${isContactRestricted ? 'bg-slate-600/50 text-slate-200 opacity-80 cursor-not-allowed' : 'bg-sky-500/10 hover:bg-sky-500/30 text-sky-400'}`}>
                                         <MapPin className="w-3.5 h-3.5" />
                                      </button>
                                   )}
                                   <button 
                                     onClick={() => {
                                        if (isContactRestricted) return alert("Mesa Redonda Bloqueada. El Líder debe subir su Perfil a ORO para reestablecer la conectividad total y mostrar las métricas del Club.");
                                        window.open(`https://wa.me/57${miembro.celular}`, '_blank');
                                     }} 
                                     title="Chat Privado" className={`p-1.5 rounded-full transition-colors shrink-0 ${isContactRestricted ? 'bg-slate-600/50 text-slate-200 opacity-80 cursor-not-allowed' : 'bg-green-500/10 hover:bg-green-500/30 text-green-500'}`}
                                   >
                                     <MessageCircle className="w-3.5 h-3.5" />
                                   </button>
                                </div>
                              )}
                              {escuadronActivo.adminId === Storage.get('gravity_user_id') && !miembro.isMe && (
                                 <button 
                                   onClick={() => { eliminarMiembroEscuadron(miembro.id); }} 
                                   className="p-1.5 rounded-full transition-colors shrink-0 bg-red-500/10 hover:bg-red-500/30 text-red-500/50 hover:text-red-500"
                                   title="Desterrar de la Mesa"
                                 >
                                   <Trash2 className="w-3.5 h-3.5" />
                                 </button>
                              )}
                             </div>

                        </motion.div>
                     );
                  })}
               </div>

               {/* Acciones Rápidas Bajas */}
               <div className="pt-2 border-t border-white/10 shrink-0 flex flex-col gap-2">
                  {escuadronActivo.isSaturated && escuadronActivo.adminId === Storage.get('gravity_user_id') && (
                     <button 
                       className="w-full flex flex-col items-center justify-center text-yellow-950 bg-gradient-to-r from-yellow-500 to-yellow-300 py-2.5 rounded-xl shadow-[0_0_20px_rgba(234,179,8,0.2)] hover:scale-[1.02] transition-transform"
                       onClick={() => { if (onOpenMembresia) onOpenMembresia(); }}
                     >
                        <div className="font-black tracking-widest text-[12px] uppercase flex items-center justify-center leading-none mb-1">
                           <Crown className="w-4 h-4 -mt-0.5 mr-1.5" /> Adquirir Licencia ORO
                        </div>
                        <span className="text-[8.5px] font-bold tracking-widest opacity-80 uppercase leading-none text-center px-2">
                           Para habilitar todos los beneficios de tu Club y ganar puntos
                        </span>
                     </button>
                  )}
                  <button 
                    onClick={abandonarEscuadron}
                    className="w-full text-center bg-white/5 border border-white/10 hover:bg-white/10 hover:border-slate-500 text-slate-300 rounded-xl text-[10px] font-black uppercase tracking-widest py-3 flex justify-center items-center gap-1.5 transition-all shadow-inner"
                  >
                     <LogOut className="w-3.5 h-3.5 mb-0.5 opacity-70" /> Abandonar Mesa Redonda
                  </button>
                  {escuadronActivo.adminId === Storage.get('gravity_user_id') && (
                     <button 
                       onClick={eliminarEscuadronCompleto}
                       className="w-full text-center bg-red-500/5 hover:bg-red-500/15 border border-red-500/20 hover:border-red-500/50 text-red-400 hover:text-red-300 rounded-xl text-[10px] font-black uppercase tracking-widest py-3 px-4 transition-all flex justify-center items-center gap-1.5 shadow-[0_0_15px_rgba(239,68,68,0.05)]"
                     >
                        <AlertOctagon className="w-4 h-4 mb-0.5" /> Destruir Escuadrón Oficial
                     </button>
                  )}
               </div>
            </div>
          )}
        </>
      )}

      {/* OVERLAY: MESA REDONDA */}
      <AnimatePresence>
        {false && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] bg-black/95 backdrop-blur-md flex flex-col p-5"
          >
            <div className="flex justify-between items-center mb-6 shrink-0 mt-8">
               <h2 className="text-2xl font-black text-white flex items-center gap-2 uppercase tracking-wide">
                  <Shield className="w-7 h-7 text-indigo-500 drop-shadow-[0_0_15px_rgba(99,102,241,0.8)]" /> 
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-purple-400">Mesa Redonda</span>
               </h2>
               <button onClick={() => setMostrarMesaRedonda(false)} className="bg-white/10 p-2.5 rounded-full text-white hover:bg-white/20 transition-colors">
                 <X className="w-5 h-5" />
               </button>
            </div>

            {/* VISTA 1: ESPACIO DE CREACIÓN/UNIÓN */}
            {!escuadronActivo && (
              <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="flex-1 flex flex-col justify-center gap-5 max-w-sm mx-auto w-full">
                
                {modoEscuadron === 'decision' && (
                   <>
                     <div className="text-center mb-6">
                        <Trophy className="w-16 h-16 text-slate-700 mx-auto mb-4" />
                        <h3 className="text-slate-300 text-sm font-bold uppercase tracking-wider mb-1">Aún no perteneces a nada</h3>
                        <p className="text-slate-500 text-[11px]">Un Escuadrón te permite competir en kilometraje con tus amigos.</p>
                     </div>
                     <button onClick={() => setModoEscuadron('fundar')} className="group w-full bg-gradient-to-r from-indigo-600 to-indigo-900 border border-indigo-400/50 p-6 rounded-3xl text-left relative overflow-hidden shadow-[0_10px_30px_rgba(99,102,241,0.2)] hover:shadow-[0_10px_40px_rgba(99,102,241,0.4)] transition-all">
                        <Shield className="absolute right-[-20px] bottom-[-20px] w-32 h-32 text-indigo-400/10 group-hover:text-indigo-400/20 transition-colors transform group-hover:scale-110" />
                        <h4 className="text-white font-black text-xl mb-1 flex items-center gap-2 uppercase tracking-wide"><Crown className="w-5 h-5 text-indigo-300" /> FUNDAR ESCUADRÓN</h4>
                        <p className="text-indigo-200/60 text-xs font-medium relative z-10 max-w-[80%]">Crea tu propio parche. Serás el Capitán con poder de administración local.</p>
                     </button>

                     <div className="flex items-center gap-3 my-2 opacity-50">
                        <div className="h-px bg-white/20 flex-1"></div>
                        <span className="text-white text-[9px] font-black uppercase tracking-widest">Ó SÚMATE A UNO</span>
                        <div className="h-px bg-white/20 flex-1"></div>
                     </div>

                     <button onClick={() => setModoEscuadron('unirse')} className="group w-full bg-slate-800/50 border border-slate-700 p-6 rounded-3xl text-left relative overflow-hidden hover:bg-slate-800 hover:border-slate-500 transition-all">
                        <Zap className="absolute right-[-10px] bottom-[-10px] w-24 h-24 text-slate-600/20 group-hover:text-slate-500/30 transition-colors transform group-hover:-rotate-12" />
                        <h4 className="text-white font-black text-lg mb-1 flex items-center gap-2 uppercase tracking-wide"><Users className="w-5 h-5 text-slate-400" /> INYECTAR CÓDIGO</h4>
                        <p className="text-slate-400 text-xs font-medium relative z-10">¿Tu parche ya existe? Ingresa el código serial para aparecer en su tablero.</p>
                     </button>
                   </>
                )}

                {modoEscuadron === 'fundar' && (
                   <div className="bg-indigo-950/40 border border-indigo-500/30 p-6 rounded-3xl">
                      <h4 className="text-white font-black text-lg mb-2 uppercase tracking-wider">Nombre del Club Oficial</h4>
                      <p className="text-slate-400 text-[11px] mb-5">Elige bajo qué estandarte correrán.</p>
                      <input 
                        type="text" 
                        placeholder="Ej: Ángeles del Asfalto"
                        value={nuevoNombreEscuadron}
                        onChange={e => setNuevoNombreEscuadron(e.target.value.toUpperCase())}
                        className="w-full bg-black/50 border border-indigo-500/40 text-indigo-100 font-black text-center text-lg p-4 rounded-2xl outline-none focus:border-indigo-400 focus:bg-indigo-900/20 transition-all uppercase mb-4 shadow-inner"
                      />
                      <div className="flex gap-3 mt-6">
                        <button onClick={() => setModoEscuadron('decision')} className="flex-1 py-3 text-slate-400 hover:text-white font-bold text-xs uppercase transition-colors">Volver</button>
                        <button 
                          onClick={crearEscuadron} 
                          disabled={creandoEscuadron || !nuevoNombreEscuadron.trim()} 
                          className={`flex-[2] py-3 text-white rounded-xl font-black uppercase text-xs tracking-widest transition-all ${creandoEscuadron ? 'bg-slate-700 text-slate-400 cursor-not-allowed opacity-50' : 'bg-indigo-600 hover:bg-indigo-500 shadow-[0_0_20px_rgba(99,102,241,0.5)] active:scale-95'}`}
                        >
                          {creandoEscuadron ? (
                            <span className="flex items-center justify-center gap-1.5">
                              <RefreshCw className="w-3.5 h-3.5 animate-spin" /> Creando...
                            </span>
                          ) : (
                            'Erigir Mesa'
                          )}
                        </button>
                      </div>
                   </div>
                )}

                {modoEscuadron === 'unirse' && (
                   <div className="bg-slate-900/80 border border-slate-700 p-6 rounded-3xl">
                      <h4 className="text-white font-black text-lg mb-2 uppercase tracking-wider">Buscar Respaldo</h4>
                      <p className="text-slate-400 text-[11px] mb-5">Pídele al Capitán el código secreto (Ej: ANG-401).</p>
                      <input 
                        type="text" 
                        placeholder="COD-XXXX"
                        value={codigoUnirse}
                        onChange={e => setCodigoUnirse(e.target.value.toUpperCase())}
                        className="w-full bg-black/50 border border-slate-600 text-white font-black text-center font-mono text-xl p-4 rounded-2xl outline-none focus:border-white transition-all uppercase mb-4 shadow-inner"
                      />
                      <div className="flex gap-3 mt-6">
                        <button onClick={() => setModoEscuadron('decision')} className="flex-1 py-3 text-slate-400 hover:text-white font-bold text-xs uppercase transition-colors">Volver</button>
                        <button onClick={unirseEscuadron} disabled={!codigoUnirse.trim()} className="flex-[2] py-3 bg-white text-black rounded-xl font-black uppercase text-xs tracking-widest hover:bg-slate-200 active:scale-95 transition-all disabled:opacity-50">Vincularse</button>
                      </div>
                   </div>
                )}

              </motion.div>
            )}

            {/* VISTA 2: EL CUARTEL GENERAL (LEADERBOARD) */}
            {escuadronActivo && (
               <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="flex-1 flex flex-col h-full overflow-hidden">
                  
                  {/* Header Dashboard */}
                  <div className="bg-gradient-to-r from-black/80 to-indigo-950/80 border border-indigo-500/30 p-3.5 px-4 rounded-2xl mb-3 flex flex-col shadow-[0_10px_30px_rgba(0,0,0,0.5)] shrink-0">
                     <div className="flex justify-between items-center mb-1">
                        <span className="text-indigo-400 text-[9px] font-black uppercase tracking-widest">Cuartel Activo</span>
                        <button 
                           onClick={() => { setActualizando(true); fetchEscuadronActivo().finally(() => setTimeout(() => setActualizando(false), 500)); }}
                           className={`p-1.5 rounded-full bg-indigo-500/10 hover:bg-indigo-500/30 text-indigo-400 transition-colors ${actualizando ? 'opacity-50' : ''}`}
                           disabled={actualizando}
                           title="Sincronizar Pilotos"
                        >
                           <RefreshCw className={`w-3.5 h-3.5 ${actualizando ? 'animate-spin text-white' : ''}`} />
                        </button>
                     </div>
                     <div className="flex justify-between items-start mb-3">
                        <div className="flex max-w-[80%]">
                          <h3 
                            onClick={escuadronActivo.adminId === Storage.get('gravity_user_id') ? editarNombreEscuadron : undefined} 
                            className={`text-white font-black text-xl uppercase tracking-tighter leading-none break-words ${escuadronActivo.adminId === Storage.get('gravity_user_id') ? 'cursor-pointer hover:text-indigo-300 transition-colors' : ''}`}
                            title={escuadronActivo.adminId === Storage.get('gravity_user_id') ? "Toca para Editar Nombre" : ""}
                          >
                             {escuadronActivo.nombre} {escuadronActivo.adminId === Storage.get('gravity_user_id') && <Edit3 className="inline w-3.5 h-3.5 ml-1 mb-1 text-indigo-400 opacity-60" />}
                          </h3>
                        </div>
                        {escuadronActivo.adminId === Storage.get('gravity_user_id') && escuadronActivo.isPremium && <Crown className="w-5 h-5 text-yellow-500 shrink-0 shadow-lg glow" />}
                     </div>
                     <div className="flex justify-between items-center bg-black/60 p-2 px-3 rounded-xl border border-white/5 box-shadow-inner">
                        <div>
                           <span className="text-slate-500 text-[9px] uppercase font-bold tracking-widest block">Código de Envío</span>
                           <span className="text-indigo-300 font-mono font-bold text-[13px] tracking-widest">{escuadronActivo.codigo}</span>
                        </div>
                        <button onClick={compartirClaveWhatsApp} className="bg-indigo-600/30 hover:bg-indigo-600 text-indigo-300 hover:text-white px-3 py-1.5 rounded-lg text-[10px] font-black uppercase transition-all flex items-center gap-1">
                           <Copy className="w-3 h-3" /> Compartir Clave
                        </button>
                     </div>
                  </div>

                  {/* Navegación y Vistas */}
                  <div className="flex gap-2 mb-4 px-1 shrink-0">
                     <button onClick={() => setMostrarModalRutasClub(true)} className="flex-1 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 rounded-xl text-[10px] font-black uppercase tracking-widest text-white py-2 flex items-center justify-center gap-1.5 shadow-[0_0_15px_rgba(37,99,235,0.4)] active:scale-95 transition-all border border-blue-500/50">
                        <MapPin className="w-4 h-4" /> 📍 Rutas Oficiales
                     </button>
                     <button onClick={() => setMostrarChat(true)} className="flex-1 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-500 hover:to-indigo-600 rounded-xl text-[10px] font-black uppercase tracking-widest text-white py-2 flex items-center justify-center gap-1.5 shadow-[0_0_15px_rgba(79,70,229,0.4)] active:scale-95 transition-all border border-indigo-500/50">
                        <MessageCircle className="w-4 h-4" /> 💬 Chat de Club
                     </button>
                  </div>

                  {/* Leaderboard Competitivo */}
                  <div className="flex items-center justify-between mb-2 px-2 shrink-0">
                     <h4 className="text-white font-black text-[14px] uppercase tracking-wider flex items-center gap-2">
                        <Activity className="w-4 h-4 text-emerald-400" /> Rendimiento Global
                     </h4>
                  </div>

                  <div className="flex-1 overflow-y-auto space-y-2 pb-8 pr-1">
                     {miembrosEscuadron.sort((a,b) => b.kms - a.kms).map((miembro, index) => {
                        const top3 = index < 3;
                        const isFirst = index === 0;
                        const apagadoDictatorial = !escuadronActivo.isPremium && miembrosEscuadron.length > 3;
                        const isContactRestricted = apagadoDictatorial;
                        
                        const leaderIsFree = apagadoDictatorial;

                        return (
                           <motion.div 
                              key={miembro.id}
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: index * 0.1 }}
                              className={`flex items-center bg-black border p-2.5 rounded-xl relative overflow-hidden transition-all ${miembro.isMe ? (leaderIsFree ? 'border-slate-500 bg-slate-700/50' : 'border-indigo-500/50 shadow-[0_0_20px_rgba(99,102,241,0.15)] bg-indigo-950/20') : 'border-white/10 hover:border-white/20'}`}
                           >
                              {miembro.isMe && !leaderIsFree && <div className="absolute top-0 right-0 w-2 h-full bg-indigo-500"></div>}
                              {miembro.isMe && leaderIsFree && <div className="absolute top-0 right-0 w-2 h-full bg-slate-300"></div>}
                              

                             {/* Foto de Perfil del Miembro */}
                             <div className="relative shrink-0 mr-3">
                                <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(0,0,0,0.4)] border border-white/10 overflow-hidden">
                                {miembro.avatarUrl ? (
                                   <img src={miembro.avatarUrl} alt={miembro.alias} className="w-full h-full object-cover" />
                                ) : (
                                   <div className={`w-full h-full flex items-center justify-center bg-gradient-to-br ${miembro.isMe ? 'from-indigo-600 to-purple-600' : 'from-slate-700 to-slate-800'}`}>
                                      <span className="text-white font-black text-sm uppercase">{miembro.alias.charAt(0)}</span>
                                   </div>
                                )}
                                </div>
                                
                                <div className={`absolute -bottom-1 -right-0.5 w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-black border-2 border-black shadow-lg z-10 ${leaderIsFree ? 'bg-slate-600 text-slate-200' : isFirst ? 'bg-gradient-to-tr from-yellow-600 to-yellow-400 text-yellow-950 shadow-yellow-500/20' : (!escuadronActivo.isSaturated || top3) ? 'bg-slate-700 text-white' : 'bg-slate-800 text-slate-500'}`}>
                                   #{index + 1}
                                </div>
                             </div>
                              
                              <div className="flex-1 min-w-0">
                                 <div className="flex items-center gap-1.5">
                                    <h5 className={`font-black text-[13px] uppercase truncate ${leaderIsFree ? 'text-slate-100 drop-shadow-md' : miembro.isMe ? 'text-indigo-300' : 'text-white'}`}>{miembro.alias}</h5>
                                    {miembro.esOro && <Crown className={`w-3.5 h-3.5 ${leaderIsFree ? 'text-slate-300' : 'text-yellow-500'}`} />}
                                 </div>
                                 <p className={`text-[9px] font-mono tracking-widest truncate ${leaderIsFree ? 'text-slate-300' : 'text-slate-400'}`}>{miembro.moto}</p>
                              </div>

                              <div className="flex items-center gap-2.5">
                                 <div className="text-right">
                                    <span className={`block font-black text-lg leading-none tabular-nums ${leaderIsFree ? 'text-slate-100 drop-shadow-md' : isFirst ? 'text-yellow-400 drop-shadow-[0_0_8px_rgba(234,179,8,0.5)]' : 'text-emerald-400'}`}>{miembro.kms.toLocaleString('es-CO')}</span>
                                    <span className={`text-[9px] uppercase font-bold tracking-widest ${leaderIsFree ? 'text-slate-300' : 'text-slate-500'}`}>KMs</span>
                                 </div>
                                 
                                 {/* Controles del Capitán / WhatsApp */}
                                 {miembro.celular && !miembro.isMe && (
                                   <div className="flex items-center gap-0.5">
                                      {escuadronActivo.adminId === Storage.get('gravity_user_id') && (
                                         <button disabled={isContactRestricted} onClick={() => enviarUbicacionDirecta(miembro.celular)} title="Mandar GPS Privado" className={`p-1.5 rounded-full transition-colors shrink-0 ${isContactRestricted ? 'bg-slate-600/50 text-slate-200 opacity-80 cursor-not-allowed' : 'bg-sky-500/10 hover:bg-sky-500/30 text-sky-400'}`}>
                                            <MapPin className="w-3.5 h-3.5" />
                                         </button>
                                      )}
                                      <button 
                                        onClick={() => {
                                           if (isContactRestricted) return alert("Mesa Redonda Bloqueada. El Líder debe subir su Perfil a ORO para reestablecer la conectividad total y mostrar las métricas del Club.");
                                           window.open(`https://wa.me/57${miembro.celular}`, '_blank');
                                        }} 
                                        title="Chat Privado" className={`p-1.5 rounded-full transition-colors shrink-0 ${isContactRestricted ? 'bg-slate-600/50 text-slate-200 opacity-80 cursor-not-allowed' : 'bg-green-500/10 hover:bg-green-500/30 text-green-500'}`}
                                      >
                                        <MessageCircle className="w-3.5 h-3.5" />
                                      </button>
                                   </div>
                                 )}
                                 {escuadronActivo.adminId === Storage.get('gravity_user_id') && !miembro.isMe && (
                                    <button 
                                      onClick={() => { eliminarMiembroEscuadron(miembro.id); }} 
                                      className="p-1.5 rounded-full transition-colors shrink-0 bg-red-500/10 hover:bg-red-500/30 text-red-500/50 hover:text-red-500"
                                      title="Desterrar de la Mesa"
                                    >
                                      <Trash2 className="w-3.5 h-3.5" />
                                    </button>
                                 )}
                                </div>

                           </motion.div>
                        );
                     })}
                  </div>


                  {/* Acciones Rápidas Bajas */}
                  <div className="pt-2 border-t border-white/10 shrink-0 flex flex-col gap-2">
                     {escuadronActivo.isSaturated && escuadronActivo.adminId === Storage.get('gravity_user_id') && (
                        <button 
                          className="w-full flex flex-col items-center justify-center text-yellow-950 bg-gradient-to-r from-yellow-500 to-yellow-300 py-2.5 rounded-xl shadow-[0_0_20px_rgba(234,179,8,0.2)] hover:scale-[1.02] transition-transform"
                          onClick={() => { if (onOpenMembresia) onOpenMembresia(); }}
                        >
                           <div className="font-black tracking-widest text-[12px] uppercase flex items-center justify-center leading-none mb-1">
                              <Crown className="w-4 h-4 -mt-0.5 mr-1.5" /> Adquirir Licencia ORO
                           </div>
                           <span className="text-[8.5px] font-bold tracking-widest opacity-80 uppercase leading-none text-center px-2">
                              Para habilitar todos los beneficios de tu Club y ganar puntos
                           </span>
                        </button>
                     )}
                     <button 
                       onClick={abandonarEscuadron}
                       className="w-full text-center bg-white/5 border border-white/10 hover:bg-white/10 hover:border-slate-500 text-slate-300 rounded-xl text-[10px] font-black uppercase tracking-widest py-3 flex justify-center items-center gap-1.5 transition-all shadow-inner"
                     >
                        <LogOut className="w-3.5 h-3.5 mb-0.5 opacity-70" /> Abandonar Mesa Redonda
                     </button>
                     {escuadronActivo.adminId === Storage.get('gravity_user_id') && (
                        <button 
                          onClick={eliminarEscuadronCompleto}
                          className="w-full text-center bg-red-500/5 hover:bg-red-500/15 border border-red-500/20 hover:border-red-500/50 text-red-400 hover:text-red-300 rounded-xl text-[10px] font-black uppercase tracking-widest py-3 px-4 transition-all flex justify-center items-center gap-1.5 shadow-[0_0_15px_rgba(239,68,68,0.05)]"
                        >
                           <AlertOctagon className="w-4 h-4 mb-0.5" /> Destruir Escuadrón Oficial
                        </button>
                     )}
                  </div>
               </motion.div>
            )}

          </motion.div>
        )}
      </AnimatePresence>

      {/* OVERRAIDES DE BROADCAST / CANJE / INVITACION ORIGINALES SIGUEN AQUÍ (EXISTENTES) */}
      
      {/* OVERLAY: MI PARCHE VIP (EXISTENTE / LOBOS SOLIDARIOS) */}
      <AnimatePresence>
        {mostrarParche && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] bg-black/90 backdrop-blur-sm flex flex-col items-center justify-center p-5"
          >
            <div className="w-full max-w-sm bg-slate-900 border border-green-500/30 rounded-3xl p-6 relative shadow-[0_0_40px_rgba(16,185,129,0.2)]">
              <button onClick={() => setMostrarParche(false)} className="absolute top-4 right-4 bg-white/10 p-2 rounded-full text-white hover:bg-white/20">
                 <X className="w-5 h-5" />
              </button>
              
              <div className="flex justify-center mb-4">
                 <Users className="w-12 h-12 text-green-400 drop-shadow-[0_0_15px_rgba(74,222,128,0.5)]" />
              </div>
              <h2 className="text-xl font-black text-white text-center mb-1 uppercase tracking-wider">Mis Referidos</h2>
              <p className="text-[11px] text-slate-400 text-center mb-4 font-medium">Lista de tus reclutas rápidos para salir o usar S.O.S.</p>

              <div className="flex flex-col gap-3 max-h-[50vh] overflow-y-auto pr-1">
                {invitadosFiltrados.length === 0 ? (
                  <p className="text-center text-slate-500 text-[11px] py-6 bg-black/20 rounded-xl border border-dashed border-white/5">No tienes reclutas sincronizados.</p>
                ) : (
                  invitadosFiltrados.map(inv => (
                    <div key={inv.id} className="bg-black/50 border border-white/10 p-3 rounded-2xl flex items-center justify-between group hover:border-white/20 transition-all">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center border shadow-inner overflow-hidden relative ${inv.esOro ? 'bg-gradient-to-tr from-yellow-600/40 to-yellow-400/10 border-yellow-500/50' : 'bg-green-500/20 border-green-500/30'}`}>
                          {inv.avatar_url ? (
                             <img src={inv.avatar_url} alt={inv.nombre} className="w-full h-full object-cover" />
                          ) : (
                             inv.esOro ? <Crown className="w-5 h-5 text-yellow-500" /> : <span className="text-green-400 font-black text-lg">{(inv.nombre || '?').charAt(0)}</span>
                          )}
                        </div>
                        <div>
                          <p className={`font-bold text-[13px] flex items-center gap-1.5 ${inv.esOro ? 'text-yellow-500' : 'text-white'}`}>
                            {inv.nombre || 'Piloto'} {inv.esOro && <span className="text-[8px] bg-yellow-500/20 px-1.5 py-0.5 rounded text-yellow-500">PRO</span>}
                          </p>
                          <p className="text-slate-400 text-[10px] font-mono tracking-wide">{inv.celular || 'Sin Número'}</p>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        {inv.celular && (
                          <button onClick={() => window.open(`https://wa.me/57${inv.celular.replace(/\D/g, '')}`, '_blank')} className="text-green-500 hover:text-green-400 p-2 transition-colors active:scale-95 bg-green-500/10 rounded-full" title="Mensaje WhatsApp">
                            <MessageCircle className="w-4 h-4" />
                          </button>
                        )}
                        <button onClick={() => eliminarInvitado(inv.id)} className="text-red-500/50 hover:text-red-500 p-2 transition-colors active:scale-95 bg-red-500/10 rounded-full" title="Expulsar">
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
              
              {/* CONTROLES DE BROADCAST MASIVOS */}
              <div className="mt-5 pt-4 border-t border-white/5 flex justify-center">
                 <button 
                   onClick={() => setMostrarBroadcast(true)}
                   className="w-[90%] bg-gradient-to-r from-blue-600/30 to-primary-cyan/20 border border-primary-cyan/40 text-primary-cyan py-2.5 px-3 rounded-xl font-black uppercase text-[10px] tracking-widest flex items-center justify-center gap-2 hover:bg-primary-cyan/30 active:scale-95 transition-all shadow-[0_0_15px_rgba(0,168,255,0.15)]"
                 >
                   <MessageCircle className="w-4 h-4 shrink-0" /> 
                   <span>Difusión Masiva In-App</span>
                 </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* POPUP: ENVIAR MENSAJE AL PARCHE (BROADCAST IN-APP) */}
      <AnimatePresence>
        {mostrarBroadcast && (
          <motion.div 
            initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 50 }}
            className="fixed inset-0 z-[80] bg-black/90 backdrop-blur-sm flex flex-col items-center justify-center p-5"
          >
            <div className="w-full max-w-sm bg-slate-900 border border-primary-cyan/50 rounded-3xl p-6 relative shadow-[0_0_50px_rgba(0,168,255,0.2)]">
               <button onClick={() => setMostrarBroadcast(false)} className="absolute top-4 right-4 text-slate-400 hover:text-white p-2">
                 <X className="w-5 h-5" />
               </button>
               <h2 className="text-lg font-black text-white text-center mb-1 uppercase tracking-wider flex items-center justify-center gap-2">
                 <MessageCircle className="w-5 h-5 text-primary-cyan" /> Anuncio Oficial
               </h2>
               <p className="text-[10px] text-slate-400 text-center mb-5 uppercase tracking-widest font-bold">Llegará a las Notificaciones de {invitadosParche.length} Pilotos</p>

               <textarea 
                  value={mensajeBroadcast}
                  onChange={e => setMensajeBroadcast(e.target.value)}
                  placeholder="Escibe tu anuncio para el parche aquí (Oculto de otros parches)..."
                  maxLength={200}
                  className="w-full h-32 bg-black/50 border border-white/10 rounded-xl p-3 text-white text-xs outline-none focus:border-primary-cyan resize-none placeholder:text-slate-600 mb-2"
               ></textarea>
               <div className="text-right text-[10px] text-slate-500 font-mono mb-4">{mensajeBroadcast.length}/200 caracteres</div>

               <button 
                  onClick={enviarBroadcastParche}
                  disabled={enviandoBroadcast || !mensajeBroadcast.trim()}
                  className="w-full bg-primary-cyan text-bg-dark py-3.5 rounded-xl font-black uppercase text-[12px] tracking-widest hover:bg-cyan-400 active:scale-95 transition-all shadow-[0_0_20px_rgba(0,168,255,0.4)] disabled:opacity-50 flex justify-center items-center gap-2"
               >
                  {enviandoBroadcast ? <Clock className="w-4 h-4 animate-spin" /> : <Navigation className="w-4 h-4" />}
                  Transmisor PUSH
               </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* OVERLAY DE CONFIRMACIÓN PROPIA */}
      <AnimatePresence>
        {dialogoConfirmacion && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[10000] bg-black/80 backdrop-blur-md flex items-center justify-center p-6"
          >
            <motion.div 
              initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 20 }}
              className={`w-full max-w-xs bg-slate-900 border ${dialogoConfirmacion.color === 'emerald' ? 'border-emerald-500/30' : dialogoConfirmacion.color === 'amber' ? 'border-yellow-500/30' : 'border-red-500/30'} rounded-3xl p-6 text-center shadow-[0_0_50px_rgba(0,0,0,0.5)] relative overflow-hidden`}
            >
              {dialogoConfirmacion.color === 'amber' && <div className="absolute top-0 left-0 w-full h-1 bg-yellow-500 opacity-50"></div>}
              
              {dialogoConfirmacion.cerrable && (
                <button 
                  onClick={() => setDialogoConfirmacion(null)}
                  className="absolute top-4 right-4 bg-white/5 hover:bg-white/10 p-2 rounded-full text-slate-400 hover:text-white transition-colors"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
              <div className={`w-16 h-16 ${dialogoConfirmacion.color === 'emerald' ? 'bg-emerald-500/10 border-emerald-500/20' : dialogoConfirmacion.color === 'amber' ? 'bg-yellow-500/10 border-yellow-500/20' : 'bg-red-500/10 border-red-500/20'} rounded-full flex items-center justify-center mx-auto mb-4 border shadow-inner`}>
                <AlertTriangle className={`w-8 h-8 ${dialogoConfirmacion.color === 'emerald' ? 'text-emerald-500' : dialogoConfirmacion.color === 'amber' ? 'text-yellow-500' : 'text-red-500'}`} />
              </div>
              <h3 className="text-white font-black text-lg mb-2 uppercase tracking-wide">{dialogoConfirmacion.titulo || '¿Estás Seguro?'}</h3>
              <p className="text-slate-400 text-[12px] font-medium leading-relaxed mb-6">{dialogoConfirmacion.mensaje}</p>
              
              <div className="flex gap-3">
                {!dialogoConfirmacion.soloAceptar && (
                  <button 
                    onClick={() => setDialogoConfirmacion(null)}
                    className="flex-1 py-3 rounded-xl border border-white/10 text-white font-bold text-[11px] uppercase tracking-wider hover:bg-white/5 transition-colors"
                  >
                    Cancelar
                  </button>
                )}
                <button 
                  onClick={dialogoConfirmacion.accion}
                  className={`flex-1 py-3 ${dialogoConfirmacion.color === 'emerald' ? 'bg-emerald-600 hover:bg-emerald-500' : dialogoConfirmacion.color === 'amber' ? 'bg-yellow-600 hover:bg-yellow-500 shadow-[0_0_15px_rgba(234,179,8,0.4)]' : 'bg-red-500 hover:bg-red-600'} text-white rounded-xl font-black text-[11px] uppercase tracking-wider active:scale-95 transition-all`}
                >
                  {dialogoConfirmacion.soloAceptar ? 'Entendido' : 'Confirmar'}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* OVERLAY INPUT NOMBRE ESCUADRON */}
      <AnimatePresence>
        {dialogoInputNombre !== null && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[210] bg-black/80 backdrop-blur-md flex items-center justify-center p-6"
          >
            <motion.div 
              initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 20 }}
              className="w-full max-w-xs bg-slate-900 border border-indigo-500/30 rounded-3xl p-6 shadow-[0_0_50px_rgba(99,102,241,0.2)]"
            >
              <div className="w-16 h-16 bg-indigo-500/10 rounded-full flex items-center justify-center mx-auto mb-4 border border-indigo-500/20 shadow-inner">
                <Edit3 className="w-8 h-8 text-indigo-400" />
              </div>
              <h3 className="text-white font-black text-lg mb-2 uppercase tracking-wide text-center">Editar Cuartel</h3>
              <p className="text-slate-400 text-[11px] font-medium leading-relaxed mb-4 text-center">Escribe el nuevo nombre oficial del club.</p>
              
              <form onSubmit={guardarNuevoNombreEscuadron}>
                 <input 
                    type="text"
                    value={dialogoInputNombre}
                    onChange={(e) => setDialogoInputNombre(e.target.value.toUpperCase())}
                    className="w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 text-white text-center font-black uppercase tracking-widest text-sm mb-6 focus:border-indigo-500 outline-none transition-colors"
                    autoFocus
                    placeholder="NUEVO NOMBRE"
                 />
                 
                 <div className="flex gap-3">
                   <button 
                     type="button"
                     onClick={() => setDialogoInputNombre(null)}
                     className="flex-1 py-3 rounded-xl border border-white/10 text-white font-bold text-[11px] uppercase tracking-wider hover:bg-white/5 transition-colors"
                   >
                     Cancelar
                   </button>
                   <button 
                     type="submit"
                     className="flex-1 py-3 bg-indigo-600 text-white rounded-xl font-black text-[11px] uppercase tracking-wider shadow-[0_0_15px_rgba(79,70,229,0.4)] hover:bg-indigo-500 active:scale-95 transition-all"
                   >
                     Guardar
                   </button>
                 </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* OVERLAY DE CANJE DE PUNTOS */}
      <AnimatePresence>
        {mostrarCanje && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[400] bg-black/90 backdrop-blur-sm flex flex-col items-center justify-center p-5"
          >
            <div className="w-full max-w-sm bg-gradient-to-b from-[#1e293b] to-[#0f172a] border border-yellow-500/30 rounded-3xl p-6 relative shadow-[0_0_40px_rgba(234,179,8,0.2)]">
              <button onClick={() => setMostrarCanje(false)} className="absolute top-4 right-4 bg-white/10 p-2 rounded-full text-white hover:bg-white/20 transition-colors">
                 <X className="w-5 h-5" />
              </button>
              
              <div className="flex justify-center mb-4">
                 <Gift className="w-12 h-12 text-yellow-400 drop-shadow-[0_0_15px_rgba(234,179,8,0.5)]" />
              </div>
              <h2 className="text-xl font-black text-white text-center mb-1 uppercase tracking-wider">Canjear Recompensas</h2>
              <p className="text-[10px] text-slate-400 text-center mb-6 font-medium">Acumula Puntos e intercámbialos.</p>
              
              <div className="flex flex-col gap-4 mb-4">
                <div className="bg-gradient-to-r from-yellow-700/20 to-yellow-900/20 border border-yellow-500/30 p-4 rounded-2xl flex flex-col relative overflow-hidden shadow-inner">
                  <div className="absolute top-0 right-0 bg-yellow-500 text-yellow-950 px-2 py-1 rounded-bl-xl text-[9px] font-black uppercase shadow-inner">
                    <Crown className="w-3 h-3 inline-block mb-0.5 mr-0.5"/> Premium
                  </div>
                  <h3 className="text-yellow-400 font-black text-[14px] uppercase mb-1 leading-tight pr-16">Suscripción ORO / PRO</h3>
                  <p className="text-slate-300 text-[10px] leading-tight mb-3">Desbloquea tú Membresía Motopikis ilimitada cancelando con Puntos.</p>
                  <button 
                    disabled={procesandoCanje || soyOroPuntos}
                    onClick={() => {
                        if (totalPuntosGanados >= 30000) {
                             procesarCanjeORO();
                        } else {
                             setMostrarCanje(false);
                             if (onOpenMembresia) onOpenMembresia();
                        }
                    }}
                    className={`w-full flex justify-between items-center ${soyOroPuntos ? 'bg-yellow-500/10 text-yellow-500 border border-yellow-500/30 shadow-inner' : 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-yellow-950 shadow-[0_0_20px_rgba(234,179,8,0.4)] hover:brightness-110 active:scale-95 border border-yellow-400'} font-black py-2.5 px-4 rounded-xl text-[12px] uppercase tracking-wider transition-all group`}
                  >
                    {soyOroPuntos ? (
                        <span className="mx-auto flex items-center gap-1.5"><Crown className="w-4 h-4"/> Membresía Activa</span>
                    ) : totalPuntosGanados >= 30000 ? (
                        <>
                           <span className="whitespace-nowrap shrink-0">{procesandoCanje ? 'Procesando...' : 'Reclamar ORO'}</span>
                           <span className="bg-black px-2.5 py-1.5 rounded-lg font-mono text-yellow-500 shadow-md whitespace-nowrap shrink-0 leading-none flex items-center justify-center">30.000 PTS</span>
                        </>
                    ) : (
                        <>
                           <div className="flex flex-col items-center justify-center leading-none gap-1.5 shrink mr-2 overflow-hidden">
                              <span className="text-yellow-950 text-[11px] uppercase tracking-tighter font-black mt-0.5 whitespace-nowrap">Faltan {30000 - totalPuntosGanados} Pts</span>
                              <span className="text-black font-black text-[10px] leading-tight flex items-center gap-1 uppercase drop-shadow-sm whitespace-nowrap"><Crown className="w-3.5 h-3.5 shrink-0" /> COMPRAR ORO 💳</span>
                           </div>
                           <span className="bg-black px-2.5 py-1.5 rounded-lg font-mono text-yellow-500 shadow-md whitespace-nowrap shrink-0 leading-none flex items-center justify-center border border-black/50">30.000 PTS</span>
                        </>
                    )}
                  </button>
                </div>
              </div>

            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* MODAL TOP-SHEET: RUTAS DE CLUB */}
      <AnimatePresence>
        {mostrarModalRutasClub && (
          <motion.div 
            initial={{ opacity: 0, y: "-100%" }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: "-100%" }}
            transition={{ type: "spring", bounce: 0, duration: 0.4 }}
            className="fixed inset-0 z-[110] bg-black/80 backdrop-blur-sm flex flex-col justify-start overflow-hidden"
          >
            <div className="absolute inset-0 z-0" onClick={() => setMostrarModalRutasClub(false)}></div>
            <div className="relative z-10 bg-[#0f172a] w-full max-w-md mx-auto h-full border-b border-blue-500/30 shadow-[0_10px_50px_rgba(59,130,246,0.15)] flex flex-col pt-8 pb-3 px-5">
               <div className="flex justify-between items-center mb-6 shrink-0 pb-4 border-b border-white/5">
                 <h2 className="text-white font-black uppercase text-[16px] tracking-wide flex items-center gap-2">
                    <MapPin className="w-5 h-5 text-primary-cyan" /> Bóveda de Misiones
                 </h2>
                 <button onClick={() => setMostrarModalRutasClub(false)} className="bg-slate-800 p-2 rounded-full border border-white/10">
                    <X className="w-5 h-5 text-slate-400" />
                 </button>
               </div>
               <div className="overflow-y-auto w-full flex-1 space-y-4 pb-20 scrollbar-hide">
                  {rutasClubArray.length === 0 ? (
                     <div className="text-center py-16 opacity-50 flex flex-col items-center">
                        <MapPin className="w-12 h-12 text-slate-500 mb-3 opacity-50"/>
                        <p className="text-[12px] font-black text-white uppercase tracking-widest">Bóveda Vacía</p>
                        <p className="text-[10px] font-medium text-slate-400 mt-2 max-w-[200px]">El Líder aún no ha compartido ninguna ruta oficial con el club.</p>
                     </div>
                  ) : (
                     rutasClubArray.map((ruta, i) => (
                        <div key={i} className="bg-gradient-to-br from-slate-900 to-[#0B1528] border border-blue-500/30 p-4 rounded-2xl flex flex-col shadow-[0_0_25px_rgba(59,130,246,0.15)] relative overflow-hidden">
                           <div className="absolute -top-10 -right-10 w-32 h-32 bg-blue-600/20 blur-[50px] rounded-full pointer-events-none"></div>
                           <h3 className="text-white font-black text-[15px] uppercase truncate leading-tight mb-2 border-b border-white/10 pb-2 relative z-10 flex justify-between items-center">
                             <span>{ruta.nombre}</span>
                             {escuadronActivo?.adminId === Storage.get('gravity_user_id') && (
                               <button 
                                 onClick={(e) => { e.stopPropagation(); expulsarDeBoveda(ruta.id); }}
                                 className="bg-red-500/10 hover:bg-red-500/30 p-1.5 rounded-md transition-colors border border-red-500/20 active:scale-95 shrink-0 ml-2"
                                 title="Expulsar de la Bóveda"
                               >
                                 <Trash2 className="w-3.5 h-3.5 text-red-500" />
                               </button>
                             )}
                           </h3>
                           <div className="flex flex-col gap-1.5 mb-3 relative z-10">
                              <p className="text-[11px] text-slate-300 uppercase tracking-widest"><span className="text-cyan-400 font-bold shrink-0">PUNTO:</span> <span className="font-bold text-white">{ruta.puntoEncuentro}</span></p>
                              <p className="text-[11px] text-slate-300 uppercase tracking-widest"><span className="text-blue-400 font-bold shrink-0">DESTINO:</span> <span className="font-bold text-white">{ruta.destino}</span></p>
                              <p className="text-[11px] text-slate-300 uppercase tracking-widest flex items-center gap-1"><span className="text-emerald-400 font-bold shrink-0">FECHA:</span> <span className="font-bold text-white">{ruta.fecha || 'Sin fecha'} {ruta.hora && `- ${ruta.hora}`}</span></p>
                           </div>
                           
                            <div className="flex justify-between items-center bg-black/40 border border-white/5 p-2 rounded-xl mb-3 relative z-10">
                              <div className="flex items-center gap-2">
                                <div className="flex -space-x-2">
                                  {(asistentesBovedaDetalle[ruta.id] || []).slice(0, 3).map((ast, idx) => (
                                    <div key={idx} className="w-5 h-5 rounded-full bg-slate-800 border border-slate-900 overflow-hidden">
                                      {ast.avatar_url ? (
                                        <img src={ast.avatar_url} className="w-full h-full object-cover" />
                                      ) : (
                                        <div className="w-full h-full flex items-center justify-center bg-indigo-600 text-[8px] font-bold text-white uppercase">
                                          {(ast.nombre || '?').charAt(0)}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                  {(asistenciasBoveda[ruta.id] || 0) === 0 && (
                                    <div className="w-5 h-5 rounded-full bg-slate-700 border border-slate-900 flex items-center justify-center"><Users className="w-3 h-3 text-white"/></div>
                                  )}
                                </div>
                                <span className="text-[10px] font-bold text-slate-300 uppercase tracking-wider">Confirmados</span>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className="text-[12px] font-black text-cyan-400 bg-cyan-900/40 px-2 py-0.5 rounded border border-cyan-500/20">{asistenciasBoveda[ruta.id] || 0} Pilotos</span>
                                <button 
                                  onClick={(e) => { e.stopPropagation(); setRutaExpandida(rutaExpandida === ruta.id ? null : ruta.id); }}
                                  className="p-1 bg-white/5 hover:bg-white/10 rounded-md transition-colors border border-white/10"
                                >
                                  <ChevronRight className={`w-4 h-4 text-slate-400 transition-transform ${rutaExpandida === ruta.id ? 'rotate-90' : ''}`} />
                                </button>
                              </div>
                            </div>

                            {/* Detalle Expandido de Participantes */}
                            <AnimatePresence>
                              {rutaExpandida === ruta.id && asistentesBovedaDetalle[ruta.id] && (
                                <motion.div 
                                  initial={{ height: 0, opacity: 0 }} 
                                  animate={{ height: "auto", opacity: 1 }} 
                                  exit={{ height: 0, opacity: 0 }}
                                  className="overflow-hidden mb-3"
                                >
                                  <div className="bg-black/20 rounded-xl p-2.5 border border-white/5 space-y-2">
                                     {asistentesBovedaDetalle[ruta.id].map((ast, idx) => (
                                       <div key={idx} className="flex items-center gap-3 bg-white/5 p-2 rounded-lg border border-transparent hover:border-white/10 transition-all">
                                          <div className="w-8 h-8 rounded-full bg-slate-800 border border-white/10 overflow-hidden shrink-0">
                                             {ast.avatar_url ? (
                                               <img src={ast.avatar_url} className="w-full h-full object-cover" />
                                             ) : (
                                               <div className="w-full h-full flex items-center justify-center bg-indigo-600 text-[10px] font-black text-white uppercase">
                                                 {(ast.nombre || '?').charAt(0)}
                                               </div>
                                             )}
                                          </div>
                                          <div className="flex-1 min-w-0">
                                             <p className="text-[11px] text-white font-black uppercase truncate leading-none">{ast.nombre}</p>
                                             <p className="text-[9px] text-cyan-400 font-mono tracking-widest mt-1 opacity-70">PLACA: {ast.placa}</p>
                                          </div>
                                          <CheckCircle className="w-4 h-4 text-green-500 opacity-60" />
                                       </div>
                                     ))}
                                  </div>
                                </motion.div>
                              )}
                            </AnimatePresence>

                           <button 
                             onClick={() => {
                               setMostrarModalRutasClub(false);
                               window.dispatchEvent(new CustomEvent('abrirInvRutaGlobal', { detail: ruta }));
                             }}
                             className="w-full relative z-10 bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-500 hover:to-cyan-400 transition-all py-2.5 rounded-xl font-black text-[12px] uppercase tracking-widest text-white shadow-[0_4px_15px_rgba(6,182,212,0.4)] active:scale-95 flex justify-center items-center gap-1.5"
                           >
                             <CheckCircle className="w-4 h-4" /> Confirmar Asistencia
                           </button>
                        </div>
                     ))
                  )}
               </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* MODAL SIMIT VIP */}
      <AnimatePresence>
        {mostrarFormSimit && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[9999] bg-black/90 backdrop-blur-sm p-4 flex flex-col items-center justify-center">
            <div className="bg-[#0f172a] border border-white/10 rounded-2xl p-5 w-full max-w-sm flex flex-col gap-4 shadow-[0_0_30px_rgba(234,179,8,0.15)] relative">
              <button onClick={() => setMostrarFormSimit(false)} className="absolute top-4 right-4 bg-slate-800 p-1.5 rounded-full text-slate-400 hover:text-white transition-colors border border-white/10 z-10">
                <X className="w-4 h-4" />
              </button>
              
              <div className="text-center mb-2 mt-2">
                <Shield className="w-10 h-10 text-yellow-500 mx-auto mb-2 drop-shadow-[0_0_15px_rgba(234,179,8,0.5)]" />
                <h3 className="text-white font-black text-[16px] uppercase tracking-wide">MESA DE CONTROL</h3>
                <p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest mt-1">Validación Oficial SIMIT</p>
              </div>

              <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-1">
                  <label className="text-[10px] text-slate-400 uppercase font-bold ml-1">NOMBRE COMPLETO DEL TITULAR</label>
                  <input 
                    type="text" 
                    value={formSimit.nombre} 
                    onChange={e => setFormSimit({...formSimit, nombre: e.target.value.toUpperCase()})}
                    className="bg-black/50 border border-slate-700 rounded-lg p-3 text-white font-black text-xs uppercase focus:outline-none focus:border-yellow-500 transition-colors"
                    placeholder="Ej. JUAN PEREZ"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-[10px] text-slate-400 uppercase font-bold ml-1">NÚMERO DE CÉDULA</label>
                  <input 
                    type="tel" 
                    value={formSimit.cedula} 
                    onChange={e => setFormSimit({...formSimit, cedula: e.target.value})}
                    className="bg-black/50 border border-slate-700 rounded-lg p-3 text-white font-black text-sm tracking-widest focus:outline-none focus:border-yellow-500 transition-colors"
                    placeholder="Sin puntos ni espacios"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-[10px] text-slate-400 uppercase font-bold ml-1">PLACA DEL VEHÍCULO</label>
                  <input 
                    type="text" 
                    value={formSimit.placa} 
                    onChange={e => setFormSimit({...formSimit, placa: e.target.value.toUpperCase()})}
                    className="bg-black/50 border border-slate-700 rounded-lg p-3 text-white font-black text-sm uppercase tracking-widest focus:outline-none focus:border-yellow-500 transition-colors"
                    placeholder="Ej. XYZ123"
                  />
                </div>
              </div>

              <div className="bg-black/40 border border-white/5 rounded-xl p-3 mt-2">
                 <p className="text-slate-400 text-[9px] text-center leading-relaxed">
                   Al confirmar, se descontarán <span className="text-yellow-500 font-bold">3.000 Puntos</span> de tu saldo.
                 </p>
              </div>

              <button 
                onClick={ejecutarCanjeSIMIT}
                className="w-full mt-1 bg-gradient-to-r from-yellow-500 to-yellow-600 text-yellow-950 font-black text-[12px] uppercase tracking-widest py-3 rounded-lg shadow-[0_0_15px_rgba(234,179,8,0.4)] hover:brightness-110 transition-all flex justify-center items-center gap-2"
              >
                CANJEAR 3.000 PUNTOS
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

                  {/* Módulo Walkie-Talkie Modal (Pantalla Completa Real) */}
                  {createPortal(
                    <AnimatePresence>

                     {mostrarChat && escuadronActivo && (
                        <motion.div 
                           className="fixed inset-0 z-[60] bg-black/95 flex flex-col p-4 backdrop-blur-md"
                           initial={{ opacity: 0, y: 50, scale: 0.95 }}
                           animate={{ opacity: 1, y: 0, scale: 1 }}
                           exit={{ opacity: 0, y: 50, scale: 0.95 }}
                        >
                           <div className="flex items-center justify-between mb-4 pt-4 shrink-0">
                              <h2 className="text-white font-black text-xl flex items-center gap-2 uppercase tracking-wide">
                                 <MessageCircle className="w-6 h-6 text-indigo-400" /> Walkie-Talkie
                              </h2>
                              <button onClick={() => setMostrarChat(false)} className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors">
                                 <X className="w-5 h-5"/>
                              </button>
                           </div>
                           
                           <div className={`flex-1 border rounded-3xl flex flex-col shadow-inner overflow-hidden relative transition-all ${escuadronActivo.isSaturated ? 'bg-red-950/20 border-red-500/30' : 'bg-indigo-950/30 border-indigo-500/20'}`}>
                              <div className={`p-3 text-center border-b shrink-0 absolute top-0 w-full z-10 backdrop-blur-sm ${escuadronActivo.isSaturated ? 'bg-red-950/80 border-red-500/30' : 'bg-indigo-950/80 border-indigo-500/20'}`}>
                                 <span className={`text-[11px] font-black uppercase tracking-widest flex justify-center items-center gap-1.5 opacity-80 ${escuadronActivo.isSaturated ? 'text-red-400' : 'text-indigo-300'}`}>
                                    {escuadronActivo.isSaturated ? <Lock className="w-4 h-4" /> : <MessageCircle className="w-4 h-4" />} 
                                    {escuadronActivo.isSaturated ? 'Frecuencia Saturada' : 'Frecuencia Radial de Club'}
                                 </span>
                              </div>
                              
                              {escuadronActivo.isSaturated ? (
                                 <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
                                    <AlertTriangle className="w-8 h-8 text-red-500/50 mb-2" />
                                    <p className="text-[12px] text-red-300 font-black tracking-widest mb-1 leading-none">CAPACIDAD LIMITADA</p>
                                    <p className="text-[10px] text-slate-400/80 max-w-[90%] leading-tight">Radio táctica en cuarentena por exceso de pilotos sin Licencia ORO.</p>
                                 </div>
                              ) : (
                                 <div className="flex-1 overflow-y-auto p-4 pt-14 space-y-4 scrollbar-hide text-[12px] font-medium mask-fade-top">
                                    {mensajesChat.length === 0 ? (
                                       <div className="text-center text-slate-500 font-medium italic mt-10">Frecuencia libre. Copie.</div>
                                    ) : (
                                       mensajesChat.map((msg, i) => {
                                         const isMeMsg = msg.emisor_id === Storage.get('gravity_user_id');
                                         return (
                                           <div key={msg.id || i} className={`w-full flex flex-col ${isMeMsg ? 'items-end' : 'items-start'}`}>
                                              <span className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1 px-1">{isMeMsg ? 'TÚ' : msg.emisor_nombre}</span>
                                              <div className={`px-4 py-3 rounded-3xl max-w-[85%] ${isMeMsg ? 'bg-indigo-600 text-white rounded-tr-sm shadow-[0_0_15px_rgba(79,70,229,0.3)]' : 'bg-slate-800 text-slate-200 rounded-tl-sm'}`}>
                                                 {msg.mensaje.split(/(https?:\/\/[^\s]+)/g).map((part: string, x: number) => 
                                                    part.match(/(https?:\/\/[^\s]+)/) 
                                                      ? <a key={x} href={part} target="_blank" rel="noopener noreferrer" className="underline font-bold break-all text-blue-200 drop-shadow-md">{part}</a> 
                                                      : <span key={x}>{part}</span>
                                                 )}
                                              </div>
                                           </div>
                                         );
                                       })
                                    )}
                                    <div ref={chatScrollRef} />
                                 </div>
                              )}

                              <form onSubmit={enviarMensajeChat} className="p-3 border-t border-white/5 shrink-0 bg-black/60 flex items-center gap-2 pb-6">
                                 {escuadronActivo.adminId === Storage.get('gravity_user_id') && (
                                   <button type="button" disabled={escuadronActivo.isSaturated} onClick={enviarUbicacionGrupo} title="Mandar GPS a Todos" className={`p-3.5 rounded-2xl transition-colors shrink-0 ${escuadronActivo.isSaturated ? 'bg-slate-800 text-slate-600 opacity-50 cursor-not-allowed' : 'bg-sky-500/20 text-sky-400 hover:bg-sky-500/40'}`}>
                                      <MapPin className="w-5 h-5" />
                                   </button>
                                 )}
                                 <input 
                                   type="text" 
                                   disabled={escuadronActivo.isSaturated}
                                   value={nuevoMensaje}
                                   onChange={(e) => setNuevoMensaje(e.target.value)}
                                   placeholder={escuadronActivo.isSaturated ? "Radio Bloqueada" : "Escribe tu mensaje..."}
                                   className={`flex-1 border rounded-2xl py-3.5 px-4 text-xs font-bold outline-none transition-colors ${escuadronActivo.isSaturated ? 'bg-black/50 border-red-500/20 text-slate-600 placeholder-slate-700 cursor-not-allowed' : 'bg-white/5 border-white/10 text-white focus:border-indigo-400 placeholder-slate-500'}`}
                                 />
                                 <button type="submit" disabled={!nuevoMensaje.trim() || escuadronActivo.isSaturated} className="bg-indigo-600 hover:bg-indigo-500 disabled:bg-slate-800 disabled:opacity-50 text-white p-3.5 rounded-2xl transition-colors active:scale-95 shadow-[0_0_20px_rgba(79,70,229,0.4)] disabled:shadow-none">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>
                                 </button>
                              </form>
                           </div>
                        </motion.div>
                     )}
                  
                    </AnimatePresence>,
                    document.body
                  )}
    </motion.div>
  );
}

